var _rect, _polygon, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _polygon5, _polygon6, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g, _g2, _g3, _g4, _path, _path2, _g5, _g6, _g7, _g8, _rect26, _rect27, _rect28, _g9, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 635.112,
    y: 75.799,
    style: {
      fill: "#FAFAFA"
    },
    width: 52.107,
    height: 180.218
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 653.657,
    y: 56.274,
    style: {
      fill: "#FAFAFA"
    },
    width: 24.715,
    height: 20.6
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 522.803,
    y: 51.661,
    style: {
      fill: "#EBEBEB"
    },
    width: 38.951,
    height: 101.953
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 542.279,
    y: 51.661,
    style: {
      fill: "#E0E0E0"
    },
    width: 19.476,
    height: 101.953
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 527.251,
    y: 39.542,
    style: {
      fill: "#EBEBEB"
    },
    width: 13.755,
    height: 12.119
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 537.727,
    y: 39.542,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.278,
    height: 12.119
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 519.557,
    y: 50.954,
    style: {
      fill: "#E0E0E0"
    },
    width: 43.337,
    height: 0.707
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 56.947,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,66.627c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C537.919,66.495,542.279,66.554,542.279,66.627z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 56.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,66.627c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C557.563,66.495,561.924,66.554,561.924,66.627z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 70.749,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,80.43c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C557.563,80.297,561.924,80.357,561.924,80.43z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 84.968,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,94.649c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C557.563,94.517,561.924,94.576,561.924,94.649z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 99.188,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,108.868c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C557.563,108.735,561.924,108.795,561.924,108.868z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 113,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,122.681c0,0.073-4.36,0.132-9.737,0.132c-5.379,0-9.738-0.059-9.738-0.132 c0-0.073,4.359-0.133,9.738-0.133C557.563,122.548,561.924,122.608,561.924,122.681z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 126.868,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 550.137,
    y: 140.918,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M561.924,136.549c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C557.563,136.416,561.924,136.476,561.924,136.549z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 70.96,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,80.64c0,0.074-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.06-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C537.919,80.508,542.279,80.567,542.279,80.64z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 84.974,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,94.654c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C537.919,94.521,542.279,94.581,542.279,94.654z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 98.987,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,108.667c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C537.919,108.535,542.279,108.594,542.279,108.667z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 113,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,122.681c0,0.073-4.36,0.132-9.737,0.132c-5.379,0-9.738-0.059-9.738-0.132 c0-0.073,4.359-0.133,9.738-0.133C537.919,122.548,542.279,122.608,542.279,122.681z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 127.014,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M542.279,136.694c0,0.073-4.36,0.133-9.737,0.133c-5.379,0-9.738-0.059-9.738-0.133 c0-0.073,4.359-0.133,9.738-0.133C537.919,136.561,542.279,136.621,542.279,136.694z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.492,
    y: 141.027,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.297,
    height: 6.952
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 422.681,
    y: 167.037,
    style: {
      fill: "#E0E0E0"
    },
    width: 45.99,
    height: 87.283
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 447.107,
    y: 167.037,
    style: {
      fill: "#EBEBEB"
    },
    width: 21.564,
    height: 87.283
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.324,
    y: 175.249,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.324,
    y: 214.57,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M447.107,189.239c0,0.087-5.469,0.157-12.213,0.157c-6.747,0-12.214-0.07-12.214-0.157 c0-0.086,5.467-0.157,12.214-0.157C441.639,189.082,447.107,189.152,447.107,189.239z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.324,
    y: 195.059,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M447.107,209.048c0,0.087-5.469,0.157-12.213,0.157c-6.747,0-12.214-0.07-12.214-0.157 c0-0.086,5.467-0.156,12.214-0.156C441.639,208.892,447.107,208.962,447.107,209.048z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 451.687,
    y: 175.249,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 460.658,
    y: 175.249,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 451.687,
    y: 194.313,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 460.658,
    y: 194.313,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 451.687,
    y: 213.377,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 460.658,
    y: 213.377,
    style: {
      fill: "#E0E0E0"
    },
    width: 4.135,
    height: 10.047
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 419.224,
    y: 164.925,
    style: {
      fill: "#E0E0E0"
    },
    width: 52.905,
    height: 2.187
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M468.992,167.318c0,0.087-10.279,0.157-22.957,0.157c-12.681,0-22.959-0.07-22.959-0.157 c0-0.086,10.277-0.156,22.959-0.156C458.713,167.162,468.992,167.232,468.992,167.318z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 601.896,
    y: 104.16,
    style: {
      fill: "#F5F5F5"
    },
    width: 39.324,
    height: 124.627
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 621.558,
    y: 104.16,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.662,
    height: 124.284
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 606.386,
    y: 91.925,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.886,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 616.963,
    y: 91.925,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.31,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "598.619,104.16 598.619,103.447 642.371,103.447 642.371,104.16  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 109.497,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,119.27c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C617.156,119.136,621.558,119.196,621.558,119.27z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 109.497,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,119.27c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,119.136,641.391,119.196,641.391,119.27z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 123.432,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,133.205c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,133.071,641.391,133.131,641.391,133.205z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 137.787,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,147.56c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,147.426,641.391,147.486,641.391,147.56z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 152.142,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.018
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,161.915c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,161.781,641.391,161.841,641.391,161.915z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 166.087,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,175.86c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,175.726,641.391,175.786,641.391,175.86z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 180.088,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 629.491,
    y: 194.272,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M641.391,189.861c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C636.989,189.727,641.391,189.787,641.391,189.861z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 123.644,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,133.418c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C617.156,133.284,621.558,133.344,621.558,133.418z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 137.792,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,147.565c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 s4.401-0.134,9.832-0.134C617.156,147.431,621.558,147.491,621.558,147.565z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 151.939,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,161.713c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C617.156,161.579,621.558,161.639,621.558,161.713z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 166.087,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,175.86c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C617.156,175.726,621.558,175.786,621.558,175.86z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 180.234,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M621.558,190.008c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C617.156,189.874,621.558,189.934,621.558,190.008z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 609.658,
    y: 194.382,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 602.069,
    y: 170.055,
    style: {
      fill: "#EBEBEB"
    },
    width: 64.539,
    height: 85.125
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 636.347,
    y: 170.055,
    style: {
      fill: "#E0E0E0"
    },
    width: 30.261,
    height: 85.125
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.601,
    y: 181.58,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.601,
    y: 236.759,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M636.347,201.212c0,0.159-7.674,0.287-17.138,0.287c-9.468,0-17.14-0.128-17.14-0.287 c0-0.158,7.672-0.287,17.14-0.287C628.673,200.925,636.347,201.053,636.347,201.212z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.601,
    y: 209.379,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M636.347,229.011c0,0.158-7.674,0.287-17.138,0.287c-9.468,0-17.14-0.128-17.14-0.287 c0-0.158,7.672-0.287,17.14-0.287C628.673,228.724,636.347,228.852,636.347,229.011z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642.773,
    y: 181.58,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 655.363,
    y: 181.58,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642.773,
    y: 208.333,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 655.363,
    y: 208.333,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642.773,
    y: 235.085,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 655.363,
    y: 235.085,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.217,
    y: 167.092,
    style: {
      fill: "#E0E0E0"
    },
    width: 74.243,
    height: 3.069
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M667.059,170.45c0,0.159-14.425,0.287-32.215,0.287c-17.797,0-32.219-0.129-32.219-0.287 c0-0.158,14.422-0.287,32.219-0.287C652.634,170.164,667.059,170.292,667.059,170.45z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 668.878,
    y: 130.91,
    style: {
      fill: "#F5F5F5"
    },
    width: 39.324,
    height: 124.627
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 688.54,
    y: 130.91,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.662,
    height: 124.284
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 673.369,
    y: 118.675,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.886,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 683.945,
    y: 118.675,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.31,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "665.601,130.91 665.601,130.197 709.353,130.197 709.353,130.91  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 136.247,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,146.02c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C684.138,145.886,688.54,145.946,688.54,146.02z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 136.247,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,146.02c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C703.972,145.886,708.373,145.946,708.373,146.02z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 150.182,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,159.955c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 s4.401-0.134,9.831-0.134C703.972,159.821,708.373,159.881,708.373,159.955z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 164.537,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,174.31c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 s4.401-0.134,9.831-0.134C703.972,174.176,708.373,174.236,708.373,174.31z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 178.892,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.018
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,188.665c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C703.972,188.531,708.373,188.591,708.373,188.665z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 192.837,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,202.61c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 s4.401-0.134,9.831-0.134C703.972,202.476,708.373,202.536,708.373,202.61z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 206.838,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 696.474,
    y: 221.022,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M708.373,216.611c0,0.074-4.402,0.134-9.83,0.134c-5.431,0-9.831-0.06-9.831-0.134 c0-0.074,4.401-0.134,9.831-0.134C703.972,216.477,708.373,216.537,708.373,216.611z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 150.394,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,160.167c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C684.138,160.033,688.54,160.094,688.54,160.167z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 164.542,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,174.315c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C684.138,174.181,688.54,174.241,688.54,174.315z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 178.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.018
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,188.462c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C684.138,188.328,688.54,188.389,688.54,188.462z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 192.837,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,202.61c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 s4.401-0.134,9.832-0.134C684.138,202.476,688.54,202.536,688.54,202.61z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 206.984,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M688.54,216.757c0,0.074-4.402,0.134-9.831,0.134c-5.431,0-9.832-0.06-9.832-0.134 c0-0.074,4.401-0.134,9.832-0.134C684.138,216.624,688.54,216.684,688.54,216.757z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.641,
    y: 221.132,
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 682.194,
    y: 204.725,
    style: {
      fill: "#EBEBEB"
    },
    width: 38.253,
    height: 50.455
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 702.512,
    y: 204.725,
    style: {
      fill: "#E0E0E0"
    },
    width: 17.936,
    height: 50.455
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 690.215,
    y: 211.557,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 690.215,
    y: 244.262,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M702.512,223.192c0,0.094-4.548,0.17-10.158,0.17c-5.611,0-10.159-0.076-10.159-0.17 c0-0.094,4.548-0.17,10.159-0.17C697.963,223.022,702.512,223.099,702.512,223.192z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 690.215,
    y: 228.033,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.357
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M702.512,239.669c0,0.094-4.548,0.17-10.158,0.17c-5.611,0-10.159-0.076-10.159-0.17 s4.548-0.17,10.159-0.17C697.963,239.499,702.512,239.575,702.512,239.669z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 706.32,
    y: 211.557,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 713.782,
    y: 211.557,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 706.32,
    y: 227.413,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 713.782,
    y: 227.413,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 706.32,
    y: 243.27,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 713.782,
    y: 243.27,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 679.319,
    y: 202.969,
    style: {
      fill: "#E0E0E0"
    },
    width: 44.004,
    height: 1.819
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M720.715,204.96c0,0.094-8.55,0.17-19.094,0.17c-10.548,0-19.096-0.076-19.096-0.17 c0-0.094,8.548-0.17,19.096-0.17C712.165,204.79,720.715,204.866,720.715,204.96z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "599.134,254.726 534.081,254.726 533.797,151.913 598.851,151.913  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 566.324,
    y: 151.913,
    style: {
      fill: "#E0E0E0"
    },
    width: 32.527,
    height: 102.813
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541.226,
    y: 131.673,
    style: {
      fill: "#EBEBEB"
    },
    width: 22.972,
    height: 20.24
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 558.722,
    y: 131.673,
    style: {
      fill: "#E0E0E0"
    },
    width: 5.475,
    height: 20.24
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 528.376,
    y: 150.733,
    style: {
      fill: "#E0E0E0"
    },
    width: 72.379,
    height: 1.181
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.638,
    y: 160.741,
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M566.324,176.909c0,0.122-7.282,0.222-16.263,0.222c-8.984,0-16.264-0.099-16.264-0.222 c0-0.123,7.28-0.222,16.264-0.222C559.042,176.687,566.324,176.786,566.324,176.909z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 579.448,
    y: 160.741,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M599.134,176.909c0,0.122-7.282,0.222-16.262,0.222 c-8.984,0-16.264-0.099-16.264-0.222c0-0.123,7.28-0.222,16.264-0.222 C591.852,176.687,599.134,176.786,599.134,176.909z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 579.448,
    y: 183.793,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M599.134,199.961c0,0.122-7.282,0.222-16.262,0.222 c-8.984,0-16.264-0.099-16.264-0.222c0-0.122,7.28-0.222,16.264-0.222 C591.852,199.739,599.134,199.839,599.134,199.961z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 579.448,
    y: 207.541,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M599.134,223.709c0,0.122-7.282,0.222-16.262,0.222 c-8.984,0-16.264-0.099-16.264-0.222c0-0.122,7.28-0.222,16.264-0.222 C591.852,223.487,599.134,223.586,599.134,223.709z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 579.448,
    y: 231.289,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M599.134,247.457c0,0.122-7.282,0.222-16.262,0.222 c-8.984,0-16.264-0.099-16.264-0.222c0-0.122,7.28-0.222,16.264-0.222 C591.852,247.235,599.134,247.334,599.134,247.457z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.638,
    y: 184.145,
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M566.324,200.313c0,0.122-7.282,0.222-16.263,0.222c-8.984,0-16.264-0.099-16.264-0.222 c0-0.122,7.28-0.221,16.264-0.221C559.042,200.091,566.324,200.19,566.324,200.313z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.638,
    y: 207.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M566.324,223.717c0,0.123-7.282,0.222-16.263,0.222c-8.984,0-16.264-0.099-16.264-0.222 c0-0.122,7.28-0.222,16.264-0.222C559.042,223.495,566.324,223.595,566.324,223.717z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.638,
    y: 230.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M566.324,247.121c0,0.123-7.282,0.222-16.263,0.222c-8.984,0-16.264-0.099-16.264-0.222 c0-0.122,7.28-0.221,16.264-0.221C559.042,246.9,566.324,246.999,566.324,247.121z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.46,
    y: 65.115,
    style: {
      fill: "#EBEBEB"
    },
    width: 53.431,
    height: 189.8
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.799,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 479.798,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 518.891,
    y: 65.115,
    style: {
      fill: "#E0E0E0"
    },
    width: 23.34,
    height: 189.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 71.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 85.696,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 99.728,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 113.76,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 127.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 141.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 155.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 169.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 183.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 197.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 211.985,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 226.017,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.797,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.796,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.795,
    y: 239.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 71.664,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 71.664,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 85.696,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 85.696,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 99.728,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 99.728,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 113.76,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 113.76,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 127.792,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 127.792,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 141.824,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 141.824,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 155.857,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 155.857,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 169.889,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 169.889,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 183.921,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 183.921,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.032
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 197.953,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 197.953,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 211.985,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 211.985,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 226.017,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 226.017,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.172,
    y: 239.274,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 534.171,
    y: 239.274,
    style: {
      fill: "#EBEBEB"
    },
    width: 4.758,
    height: 10.033
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M586.573,109.922c0.216,0,0.392,4.496,0.392,10.042c0,5.547-0.175,10.043-0.392,10.043 c-0.216,0-0.392-4.495-0.392-10.043C586.182,114.418,586.357,109.922,586.573,109.922z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "606.547,131.568 550.536,147.466 550.536,255.18 606.547,255.18  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "558.936,145.021 558.936,125.92 593.42,125.92 593.42,135.234  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "554.805,148.538 555.248,247.586 600.809,247.586 600.809,135.471  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M567.124,249.842c-0.216,0-0.392-23.768-0.392-53.082 c0-29.323,0.175-53.086,0.392-53.086c0.216,0,0.392,23.763,0.392,53.086 C567.516,226.073,567.341,249.842,567.124,249.842z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M586.274,249.842c-0.216,0-0.392-25.092-0.392-56.038 c0-30.957,0.175-56.044,0.392-56.044c0.216,0,0.392,25.087,0.392,56.044 C586.665,224.749,586.49,249.842,586.274,249.842z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M603.953,163.659c0,0.217-11.345,0.392-25.337,0.392c-13.997,0-25.34-0.175-25.34-0.392 c0-0.216,11.343-0.392,25.34-0.392C592.608,163.267,603.953,163.443,603.953,163.659z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M603.48,193.97c0,0.216-11.345,0.392-25.337,0.392c-13.997,0-25.339-0.175-25.339-0.392 c0-0.216,11.343-0.392,25.339-0.392C592.135,193.578,603.48,193.754,603.48,193.97z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M606.321,224.518c0,0.216-11.769,0.392-26.284,0.392c-14.52,0-26.287-0.175-26.287-0.392 c0-0.216,11.767-0.392,26.287-0.392C594.552,224.126,606.321,224.302,606.321,224.518z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M606.335,131.568c0.059,0.208-12.338,3.909-27.685,8.265 c-15.353,4.358-27.843,7.72-27.902,7.512c-0.059-0.208,12.335-3.908,27.688-8.266 C593.783,134.724,606.276,131.36,606.335,131.568z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M569.685,186.296c-0.153-0.153,2.602-3.156,6.152-6.706 c3.551-3.551,6.553-6.305,6.707-6.152c0.153,0.153-2.601,3.155-6.152,6.706 C572.841,183.695,569.838,186.449,569.685,186.296z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M578.247,174.103c0.149,0.157-0.843,1.343-2.215,2.648 c-1.373,1.306-2.606,2.238-2.755,2.081c-0.149-0.157,0.843-1.342,2.215-2.649 C576.864,174.878,578.097,173.947,578.247,174.103z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M581.406,208.395c0.154,0.152-2.198,2.797-5.254,5.908 c-3.057,3.112-5.659,5.511-5.813,5.359c-0.154-0.152,2.198-2.796,5.255-5.908 C578.649,210.643,581.252,208.244,581.406,208.395z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M577.107,209.737c0.16,0.145-0.621,1.271-1.744,2.514 c-1.124,1.244-2.165,2.134-2.326,1.989c-0.161-0.145,0.62-1.271,1.744-2.515 C575.905,210.483,576.946,209.592,577.107,209.737z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M596.454,148.558c0.164,0.141-1.005,1.779-2.611,3.659 c-1.607,1.88-3.042,3.29-3.207,3.15c-0.164-0.14,1.004-1.778,2.611-3.659 C594.854,149.828,596.29,148.417,596.454,148.558z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M595.149,146.568c0.161,0.145-0.67,1.323-1.855,2.63 c-1.185,1.308-2.275,2.249-2.436,2.104c-0.16-0.145,0.67-1.322,1.855-2.63 C593.899,147.365,594.99,146.423,595.149,146.568z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M562.917,235.249c0.177,0.125-0.539,1.438-1.598,2.934 c-1.059,1.495-2.061,2.606-2.237,2.481c-0.176-0.125,0.539-1.438,1.598-2.934 C561.739,236.235,562.741,235.124,562.917,235.249z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M561.563,233.445c0.158,0.148-0.472,1.076-1.406,2.073 c-0.935,0.997-1.82,1.685-1.978,1.537c-0.157-0.148,0.472-1.076,1.406-2.073 C560.52,233.985,561.406,233.297,561.563,233.445z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M113.5,42.476c-0.217,0-0.392,4.497-0.392,10.042c0,5.547,0.175,10.043,0.392,10.043 c0.216,0,0.392-4.495,0.392-10.043C113.891,46.972,113.716,42.476,113.5,42.476z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "93.526,64.123 149.537,80.02 149.537,187.734 93.526,187.734  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "141.137,77.576 141.137,58.474 106.653,58.474 106.653,67.788  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "145.268,81.092 144.825,180.14 99.264,180.14 99.264,68.025  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M132.949,182.396c0.216,0,0.392-23.769,0.392-53.081c0-29.323-0.176-53.086-0.392-53.086 c-0.216,0-0.392,23.763-0.392,53.086C132.557,158.627,132.733,182.396,132.949,182.396z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M113.799,182.396c0.216,0,0.392-25.092,0.392-56.038c0-30.956-0.175-56.043-0.392-56.043 c-0.216,0-0.392,25.087-0.392,56.043C113.408,157.303,113.583,182.396,113.799,182.396z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M96.12,96.213c0,0.216,11.346,0.392,25.337,0.392c13.997,0,25.34-0.175,25.34-0.392 c0-0.216-11.343-0.392-25.34-0.392C107.465,95.821,96.12,95.997,96.12,96.213z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M96.593,126.524c0,0.216,11.345,0.392,25.337,0.392c13.997,0,25.34-0.175,25.34-0.392 s-11.343-0.392-25.34-0.392C107.939,126.133,96.593,126.308,96.593,126.524z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M93.752,157.072c0,0.216,11.77,0.392,26.284,0.392c14.52,0,26.287-0.176,26.287-0.392 c0-0.216-11.767-0.392-26.287-0.392C105.521,156.68,93.752,156.856,93.752,157.072z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M93.738,64.123c-0.059,0.208,12.337,3.909,27.685,8.265 c15.353,4.358,27.843,7.72,27.902,7.512c0.059-0.208-12.335-3.908-27.688-8.266 C106.29,67.278,93.797,63.915,93.738,64.123z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M130.389,118.851c0.153-0.153-2.602-3.156-6.152-6.706 c-3.551-3.551-6.553-6.306-6.707-6.152c-0.153,0.153,2.601,3.155,6.153,6.707 C127.233,116.249,130.236,119.003,130.389,118.851z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M121.826,106.658c-0.149,0.157,0.843,1.343,2.215,2.648 c1.373,1.306,2.606,2.238,2.755,2.081c0.149-0.157-0.843-1.342-2.215-2.649 C123.209,107.433,121.976,106.501,121.826,106.658z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M118.667,140.949c-0.154,0.152,2.198,2.797,5.254,5.908 c3.056,3.112,5.659,5.511,5.813,5.359c0.154-0.151-2.198-2.796-5.254-5.908 C121.424,143.197,118.821,140.798,118.667,140.949z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M122.967,142.292c-0.16,0.145,0.621,1.271,1.744,2.514 c1.124,1.244,2.165,2.134,2.326,1.989c0.16-0.145-0.62-1.271-1.745-2.515 C124.168,143.037,123.127,142.146,122.967,142.292z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M103.619,81.112c-0.165,0.141,1.005,1.779,2.611,3.659c1.607,1.88,3.042,3.29,3.207,3.15 c0.165-0.141-1.004-1.778-2.611-3.659C105.219,82.382,103.783,80.972,103.619,81.112z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M104.924,79.122c-0.16,0.145,0.67,1.323,1.855,2.63c1.185,1.307,2.275,2.249,2.436,2.104 c0.16-0.145-0.67-1.323-1.855-2.63C106.174,79.919,105.084,78.977,104.924,79.122z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M137.156,167.804c-0.176,0.125,0.539,1.439,1.598,2.934 c1.059,1.495,2.061,2.606,2.237,2.48c0.176-0.125-0.539-1.438-1.598-2.934 C138.335,168.789,137.333,167.679,137.156,167.804z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M138.51,165.999c-0.158,0.148,0.472,1.076,1.406,2.073 c0.935,0.997,1.82,1.685,1.978,1.537c0.158-0.148-0.472-1.076-1.407-2.073 C139.553,166.539,138.668,165.851,138.51,165.999z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.067,
    y: 119.996,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 162.5235 348.979)",
    style: {
      fill: "#F5F5F5"
    },
    width: 34.389,
    height: 108.987
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.067,
    y: 119.996,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.329 348.679)",
    style: {
      fill: "#EBEBEB"
    },
    width: 17.195,
    height: 108.687
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.386,
    y: 109.297,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 176.9154 229.2929)",
    style: {
      fill: "#F5F5F5"
    },
    width: 12.144,
    height: 10.7
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.386,
    y: 109.297,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 167.6661 229.2929)",
    style: {
      fill: "#EBEBEB"
    },
    width: 2.894,
    height: 10.7
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "101.322,119.996 101.322,119.372 63.061,119.372 63.061,119.996  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 124.663,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 255.4631)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,133.209c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,133.092,81.262,133.145,81.262,133.209z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 124.663,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 255.4631)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,133.209c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.848-0.117-8.598-0.117C67.767,133.092,63.918,133.145,63.918,133.209z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 136.849,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 279.8355)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,145.396c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.848-0.117-8.598-0.117C67.767,145.278,63.918,145.331,63.918,145.396z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 149.402,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 304.9426)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,157.949c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.053,8.598-0.117 s-3.848-0.117-8.598-0.117C67.767,157.832,63.918,157.885,63.918,157.949z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 161.956,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 330.0504)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,170.503c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.053,8.598-0.117 c0-0.065-3.848-0.117-8.598-0.117C67.767,170.386,63.918,170.438,63.918,170.503z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 174.151,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 354.4396)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,182.698c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.053,8.598-0.117 c0-0.065-3.848-0.117-8.598-0.117C67.767,182.58,63.918,182.633,63.918,182.698z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 186.395,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 378.9275)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.413,
    y: 198.799,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.7371 403.7361)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M63.918,194.942c0,0.064,3.849,0.117,8.597,0.117c4.749,0,8.598-0.053,8.598-0.117 c0-0.065-3.848-0.117-8.598-0.117C67.767,194.824,63.918,194.877,63.918,194.942z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 137.035,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 280.2073)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,145.582c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,145.464,81.262,145.517,81.262,145.582z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 149.407,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 304.9513)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,157.953c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,157.836,81.262,157.889,81.262,157.953z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 161.779,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 329.6956)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,170.326c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,170.208,81.262,170.261,81.262,170.326z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 174.151,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 354.4396)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,182.698c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.053,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,182.58,81.262,182.633,81.262,182.698z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 186.523,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 379.1837)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M81.262,195.07c0,0.065,3.849,0.117,8.597,0.117c4.749,0,8.598-0.052,8.598-0.117 c0-0.065-3.849-0.117-8.598-0.117C85.111,194.953,81.262,195.005,81.262,195.07z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.757,
    y: 198.895,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 180.4256 403.9278)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.911,
    height: 6.138
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.933,
    y: 168.437,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 152.4052 421.9988)",
    style: {
      fill: "#EBEBEB"
    },
    width: 64.539,
    height: 85.125
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.933,
    y: 168.437,
    style: {
      fill: "#E0E0E0"
    },
    width: 30.261,
    height: 85.125
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.137,
    y: 179.962,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 184.0766 374.0225)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.137,
    y: 235.141,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 184.0766 484.3802)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M74.194,199.593c0,0.159,7.674,0.287,17.138,0.287c9.467,0,17.14-0.128,17.14-0.287 c0-0.158-7.672-0.287-17.14-0.287C81.868,199.307,74.194,199.435,74.194,199.593z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.137,
    y: 207.76,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 184.0766 429.6194)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M74.194,227.392c0,0.158,7.674,0.287,17.138,0.287c9.467,0,17.14-0.128,17.14-0.287 c0-0.158-7.672-0.287-17.14-0.287C81.868,227.105,74.194,227.234,74.194,227.392z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.965,
    y: 179.962,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 129.7331 374.0225)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.375,
    y: 179.962,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 104.5541 374.0225)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.965,
    y: 206.714,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 129.7331 427.527)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.375,
    y: 206.714,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 104.5541 427.527)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.965,
    y: 233.467,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 129.7331 481.032)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.375,
    y: 233.467,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 104.5541 481.032)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.081,
    y: 165.474,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 152.4051 334.0167)",
    style: {
      fill: "#E0E0E0"
    },
    width: 74.243,
    height: 3.069
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M43.482,168.832c0,0.159,14.425,0.287,32.215,0.287c17.796,0,32.219-0.129,32.219-0.287 c0-0.158-14.422-0.287-32.219-0.287C57.907,168.546,43.482,168.674,43.482,168.832z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.214,
    y: 82.22,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 448.7367 311.2024)",
    style: {
      fill: "#F5F5F5"
    },
    width: 46.309,
    height: 146.763
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.214,
    y: 82.22,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 425.5823 310.7984)",
    style: {
      fill: "#EBEBEB"
    },
    width: 23.154,
    height: 146.359
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.882,
    y: 67.811,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 468.1171 150.031)",
    style: {
      fill: "#F5F5F5"
    },
    width: 16.353,
    height: 14.408
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.882,
    y: 67.811,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 455.6617 150.031)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.897,
    height: 14.408
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "251.382,82.22 251.382,81.379 199.859,81.379 199.859,82.22  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 88.504,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 185.2724)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,100.013c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.183-0.158-11.578-0.158C229.552,99.855,224.368,99.926,224.368,100.013z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 88.504,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 185.2724)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,100.013c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.182-0.158-11.578-0.158C206.196,99.855,201.012,99.926,201.012,100.013z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 104.914,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 218.0927)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,116.423c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.182-0.158-11.578-0.158C206.196,116.265,201.012,116.336,201.012,116.423z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 121.818,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 251.9023)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,133.328c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.182-0.158-11.578-0.158C206.196,133.17,201.012,133.241,201.012,133.328z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 138.724,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 285.7127)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,150.233c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.182-0.158-11.578-0.158C206.196,150.075,201.012,150.146,201.012,150.233z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 155.145,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 318.5559)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,166.654c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 s-5.182-0.158-11.578-0.158C206.196,166.497,201.012,166.567,201.012,166.654z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 171.633,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 351.5315)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.106,
    y: 188.337,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 426.1318 384.9392)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M201.012,183.142c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.182-0.158-11.578-0.158C206.196,182.985,201.012,183.055,201.012,183.142z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 105.164,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 218.5933)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,116.673c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.07,11.578-0.158 c0-0.087-5.183-0.158-11.578-0.158C229.552,116.516,224.368,116.586,224.368,116.673z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 121.824,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 251.914)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,133.333c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.183-0.158-11.578-0.158C229.552,133.176,224.368,133.247,224.368,133.333z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 138.485,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 285.235)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,149.994c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.07,11.578-0.158 c0-0.087-5.183-0.158-11.578-0.158C229.552,149.836,224.368,149.907,224.368,149.994z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 155.145,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 318.5559)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,166.654c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 s-5.183-0.158-11.578-0.158C229.552,166.497,224.368,166.567,224.368,166.654z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 171.806,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 351.8766)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.368,183.315c0,0.087,5.184,0.158,11.577,0.158c6.395,0,11.578-0.071,11.578-0.158 c0-0.087-5.183-0.158-11.578-0.158C229.552,183.157,224.368,183.228,224.368,183.315z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.462,
    y: 188.466,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 472.8437 385.1975)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.92,
    height: 8.265
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.856,
    y: 170.626,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 454.251 426.3767)",
    style: {
      fill: "#EBEBEB"
    },
    width: 64.539,
    height: 85.125
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.856,
    y: 170.626,
    style: {
      fill: "#E0E0E0"
    },
    width: 30.261,
    height: 85.125
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.06,
    y: 182.151,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 485.9223 378.4004)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.06,
    y: 237.33,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 485.9223 488.7581)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M225.117,201.782c0,0.159,7.674,0.287,17.138,0.287c9.468,0,17.14-0.128,17.14-0.287 c0-0.158-7.672-0.287-17.14-0.287C232.791,201.496,225.117,201.624,225.117,201.782z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.06,
    y: 209.949,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 485.9223 433.9973)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M225.117,229.581c0,0.158,7.674,0.287,17.138,0.287c9.468,0,17.14-0.128,17.14-0.287 c0-0.158-7.672-0.287-17.14-0.287C232.791,229.294,225.117,229.423,225.117,229.581z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.888,
    y: 182.151,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 431.5787 378.4004)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.298,
    y: 182.151,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 406.3997 378.4004)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.099
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.888,
    y: 208.903,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 431.5787 431.905)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.298,
    y: 208.903,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 406.3997 431.905)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.888,
    y: 235.656,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 431.5787 485.41)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.298,
    y: 235.656,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 406.3997 485.41)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.803,
    height: 14.098
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.004,
    y: 167.663,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 454.2509 338.3946)",
    style: {
      fill: "#E0E0E0"
    },
    width: 74.243,
    height: 3.069
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M194.405,171.021c0,0.158,14.425,0.287,32.215,0.287 c17.796,0,32.218-0.129,32.218-0.287c0-0.158-14.422-0.287-32.218-0.287 C208.83,170.735,194.405,170.863,194.405,171.021z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "108.629,253.566 173.682,253.566 173.965,150.753 108.912,150.753  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.912,
    y: 150.753,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 250.3503 404.318)",
    style: {
      fill: "#E0E0E0"
    },
    width: 32.527,
    height: 102.813
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.565,
    y: 130.512,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 310.1023 281.2645)",
    style: {
      fill: "#EBEBEB"
    },
    width: 22.972,
    height: 20.24
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.565,
    y: 130.512,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.6054 281.2645)",
    style: {
      fill: "#E0E0E0"
    },
    width: 5.475,
    height: 20.24
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.008,
    y: 149.572,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 286.3948 300.3245)",
    style: {
      fill: "#E0E0E0"
    },
    width: 72.379,
    height: 1.181
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.618,
    y: 159.58,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 316.7422 330.7711)",
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.439,175.748c0,0.122,7.282,0.222,16.263,0.222c8.984,0,16.264-0.099,16.264-0.222 s-7.28-0.222-16.264-0.222C148.721,175.526,141.439,175.626,141.439,175.748z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.808,
    y: 159.58,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.1222 330.7711)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M108.629,175.748c0,0.122,7.282,0.222,16.263,0.222 c8.984,0,16.264-0.099,16.264-0.222s-7.28-0.222-16.264-0.222C115.911,175.526,108.629,175.626,108.629,175.748z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.808,
    y: 182.633,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.1222 376.8757)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M108.629,198.8c0,0.123,7.282,0.222,16.263,0.222c8.984,0,16.264-0.099,16.264-0.222 c0-0.122-7.28-0.222-16.264-0.222C115.911,198.579,108.629,198.678,108.629,198.8z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.808,
    y: 206.38,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.1222 424.3713)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M108.629,222.548c0,0.122,7.282,0.222,16.263,0.222 c8.984,0,16.264-0.099,16.264-0.222c0-0.123-7.28-0.222-16.264-0.222 C115.911,222.327,108.629,222.426,108.629,222.548z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.808,
    y: 230.128,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.1222 471.8672)",
    style: {
      fill: "#F5F5F5"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M108.629,246.296c0,0.122,7.282,0.222,16.263,0.222 c8.984,0,16.264-0.099,16.264-0.222c0-0.122-7.28-0.222-16.264-0.222 C115.911,246.074,108.629,246.174,108.629,246.296z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.618,
    y: 182.984,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 316.7422 377.5792)",
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.439,199.152c0,0.122,7.282,0.222,16.263,0.222c8.984,0,16.264-0.1,16.264-0.222 c0-0.122-7.28-0.221-16.264-0.221C148.721,198.93,141.439,199.03,141.439,199.152z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.618,
    y: 206.388,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 316.7422 424.3877)",
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.439,222.556c0,0.122,7.282,0.222,16.263,0.222c8.984,0,16.264-0.099,16.264-0.222 c0-0.122-7.28-0.222-16.264-0.222C148.721,222.335,141.439,222.434,141.439,222.556z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.618,
    y: 229.793,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 316.7422 471.1959)",
    style: {
      fill: "#FFFFFF"
    },
    width: 5.506,
    height: 11.611
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.439,245.96c0,0.123,7.282,0.222,16.263,0.222c8.984,0,16.264-0.099,16.264-0.222 c0-0.122-7.28-0.221-16.264-0.221C148.721,245.739,141.439,245.838,141.439,245.96z"
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.931,
    y: 129.98,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 597.187 384.586)",
    style: {
      fill: "#F5F5F5"
    },
    width: 39.324,
    height: 124.627
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.931,
    y: 129.98,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.525 384.243)",
    style: {
      fill: "#EBEBEB"
    },
    width: 19.662,
    height: 124.284
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.879,
    y: 117.745,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 613.6442 247.7241)",
    style: {
      fill: "#F5F5F5"
    },
    width: 13.886,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.879,
    y: 117.745,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 603.0676 247.7241)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.31,
    height: 12.235
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "321.533,129.98 321.533,129.266 277.781,129.266 277.781,129.98  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 135.316,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 277.6498)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,145.089c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,144.955,298.594,145.015,298.594,145.089z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 135.316,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 277.6498)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,145.089c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,144.955,278.76,145.015,278.76,145.089z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 149.251,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 305.5199)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,159.024c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,158.89,278.76,158.95,278.76,159.024z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 163.606,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 334.2301)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,173.379c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,173.245,278.76,173.305,278.76,173.379z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 177.961,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 362.9409)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.018
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,187.734c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,187.6,278.76,187.66,278.76,187.734z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 191.906,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 390.8303)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,201.679c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,201.545,278.76,201.605,278.76,201.679z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 205.907,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 418.8323)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.331,
    y: 220.091,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 577.9916 447.2011)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M278.76,215.68c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.832-0.06,9.832-0.134 c0-0.074-4.401-0.134-9.832-0.134C283.162,215.546,278.76,215.606,278.76,215.68z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 149.463,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 305.945)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,159.237c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,159.103,298.594,159.163,298.594,159.237z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 163.611,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 334.2401)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,173.384c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,173.25,298.594,173.31,298.594,173.384z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 177.758,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 362.5352)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,187.531c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,187.398,298.594,187.458,298.594,187.531z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 191.906,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 390.8303)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,201.679c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,201.545,298.594,201.605,298.594,201.679z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 206.053,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 419.1254)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M298.594,215.827c0,0.074,4.402,0.134,9.831,0.134c5.431,0,9.831-0.06,9.831-0.134 c0-0.074-4.401-0.134-9.831-0.134C302.995,215.693,298.594,215.753,298.594,215.827z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.165,
    y: 220.201,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.658 447.4204)",
    style: {
      fill: "#FAFAFA"
    },
    width: 3.329,
    height: 7.019
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.63,
    y: 155.664,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 716.4806 410.2707)",
    style: {
      fill: "#F5F5F5"
    },
    width: 31.22,
    height: 98.942
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.63,
    y: 155.664,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 700.8709 409.9983)",
    style: {
      fill: "#EBEBEB"
    },
    width: 15.61,
    height: 98.67
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.261,
    y: 145.951,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 729.5462 301.615)",
    style: {
      fill: "#F5F5F5"
    },
    width: 11.024,
    height: 9.713
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.261,
    y: 145.951,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 721.1493 301.615)",
    style: {
      fill: "#EBEBEB"
    },
    width: 2.627,
    height: 9.713
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E0E0E0"
    },
    points: "376.452,155.664 376.452,155.098 341.717,155.098 341.717,155.664  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 159.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 325.3732)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,167.66c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.047,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,167.553,358.24,167.601,358.24,167.66z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 159.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 325.3732)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,167.66c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.047,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C345.989,167.553,342.495,167.601,342.495,167.66z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 170.964,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 347.4994)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,178.723c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 s-3.494-0.106-7.805-0.106C345.989,178.616,342.495,178.664,342.495,178.723z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 182.36,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 370.2928)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,190.12c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C345.989,190.013,342.495,190.061,342.495,190.12z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 193.757,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 393.0865)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,201.516c0,0.059,3.495,0.107,7.805,0.107c4.311,0,7.805-0.048,7.805-0.107 c0-0.059-3.494-0.106-7.805-0.106C345.989,201.41,342.495,201.458,342.495,201.516z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 204.828,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 415.2281)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,212.587c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C345.989,212.481,342.495,212.528,342.495,212.587z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 215.943,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 437.4589)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.299,
    y: 227.204,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.2412 459.9812)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M342.495,223.702c0,0.059,3.495,0.107,7.805,0.107c4.311,0,7.805-0.048,7.805-0.107 s-3.494-0.106-7.805-0.106C345.989,223.596,342.495,223.644,342.495,223.702z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 171.132,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 347.8369)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,178.892c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,178.785,358.24,178.833,358.24,178.892z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 182.364,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 370.3006)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,190.123c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,190.017,358.24,190.065,358.24,190.123z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 193.596,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 392.7643)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,201.355c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,201.249,358.24,201.297,358.24,201.355z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 204.828,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 415.2281)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,212.587c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,212.481,358.24,212.528,358.24,212.587z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 216.06,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 437.6917)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M358.24,223.819c0,0.059,3.495,0.106,7.805,0.106c4.311,0,7.805-0.048,7.805-0.106 c0-0.059-3.494-0.106-7.805-0.106C361.735,223.712,358.24,223.76,358.24,223.819z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 227.292,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 732.7326 460.1555)",
    style: {
      fill: "#FAFAFA"
    },
    width: 2.643,
    height: 5.572
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.686,
    y: 203.795,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 571.6257 458.0438)",
    style: {
      fill: "#EBEBEB"
    },
    width: 38.253,
    height: 50.455
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.686,
    y: 203.795,
    style: {
      fill: "#E0E0E0"
    },
    width: 17.936,
    height: 50.455
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.479,
    y: 210.626,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 590.3977 429.6076)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.479,
    y: 243.331,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 590.3977 495.0179)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M284.622,222.262c0,0.094,4.549,0.17,10.158,0.17c5.612,0,10.159-0.076,10.159-0.17 c0-0.094-4.547-0.17-10.159-0.17C289.171,222.092,284.622,222.168,284.622,222.262z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.479,
    y: 227.102,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 590.3977 462.5606)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M284.622,238.738c0,0.094,4.549,0.17,10.158,0.17c5.612,0,10.159-0.076,10.159-0.17 c0-0.094-4.547-0.17-10.159-0.17C289.171,238.568,284.622,238.645,284.622,238.738z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.374,
    y: 210.626,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 558.1876 429.6076)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.912,
    y: 210.626,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 543.2638 429.6076)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.374,
    y: 226.482,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 558.1876 461.3206)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.912,
    y: 226.482,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 543.2638 461.3206)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.374,
    y: 242.339,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 558.1876 493.0335)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.439,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.912,
    y: 242.339,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 543.2638 493.0335)",
    style: {
      fill: "#F5F5F5"
    },
    width: 3.44,
    height: 8.356
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.811,
    y: 202.038,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 571.6256 405.8958)",
    style: {
      fill: "#E0E0E0"
    },
    width: 44.004,
    height: 1.819
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M266.419,204.029c0,0.094,8.55,0.17,19.094,0.17c10.548,0,19.096-0.076,19.096-0.17 c0-0.094-8.548-0.17-19.096-0.17C274.969,203.859,266.419,203.935,266.419,204.029z"
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 205.432,
    cy: 452.468,
    rx: 166.41,
    ry: 16.42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 456.092,
    cy: 356.293,
    rx: 52.749,
    ry: 6.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 572.193,
    cy: 312.58,
    rx: 48.149,
    ry: 13.345
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M692.353,459.471c0,3.868-47.05,7.003-105.088,7.003s-105.088-3.135-105.088-7.003 c0-3.868,47.05-7.003,105.088-7.003S692.353,455.603,692.353,459.471z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 539.961,
    y: 408.378,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M581.841,446.841c0,0-0.017-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.318-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.061,0.055,0.489-0.49,0.257-0.254v0.01v0.021v0.041v0.082v0.164v0.328v0.655 l0,1.306c0,0.869,0,1.735,0,2.597c0,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.009,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.66,0.026,6.548,0.046,8.552,0.06c0.973,0.011,1.731,0.02,2.272,0.027c0.244,0.005,0.436,0.01,0.589,0.013 C581.766,446.832,581.836,446.836,581.841,446.841c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.531,0.006-1.273,0.015-2.227,0.027c-1.991,0.014-4.863,0.034-8.5,0.06c-7.384,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c0-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597l0-1.306l0-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.869-0.019,1.546-0.026,2.032 C581.857,446.618,581.841,446.841,581.841,446.841z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.209,
    y: 409.096,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.209,
    y: 436.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M581.835,426.477c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 s9.511-0.26,21.247-0.26C572.322,426.217,581.835,426.333,581.835,426.477z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 539.961,
    y: 369.745,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M581.841,408.208c0,0-0.017-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.317-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.061,0.055,0.489-0.49,0.257-0.254v0.01v0.021v0.041v0.082v0.164v0.328v0.655 l0,1.306c0,0.869,0,1.735,0,2.597c0,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.009,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.66,0.026,6.548,0.046,8.552,0.06c0.973,0.012,1.731,0.02,2.272,0.027c0.244,0.005,0.436,0.01,0.589,0.013 C581.766,408.199,581.836,408.203,581.841,408.208c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.531,0.006-1.273,0.015-2.227,0.027c-1.991,0.014-4.863,0.034-8.5,0.06c-7.384,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c0-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597l0-1.306l0-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.87-0.019,1.546-0.026,2.032 C581.857,407.985,581.841,408.208,581.841,408.208z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.209,
    y: 370.463,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.209,
    y: 398.129,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M581.835,387.844c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 c0-0.144,9.511-0.26,21.247-0.26C572.322,387.584,581.835,387.701,581.835,387.844z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 496.017,
    y: 408.378,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M537.897,446.841c0,0-0.016-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.318-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.061,0.055,0.489-0.49,0.257-0.254v0.01v0.021v0.041v0.082v0.164v0.328l0,0.655 v1.306c0,0.869,0,1.735,0,2.597c-0.001,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.008,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.659,0.026,6.548,0.046,8.552,0.06c0.973,0.011,1.731,0.02,2.272,0.027c0.244,0.005,0.436,0.01,0.59,0.013 C537.823,446.832,537.893,446.836,537.897,446.841c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.531,0.006-1.273,0.015-2.227,0.027c-1.991,0.014-4.863,0.034-8.5,0.06c-7.383,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c-0.001-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597v-1.306l0-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.869-0.019,1.546-0.026,2.032 C537.914,446.618,537.897,446.841,537.897,446.841z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.265,
    y: 409.096,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.265,
    y: 436.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M537.892,426.477c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 s9.511-0.26,21.247-0.26C528.379,426.217,537.892,426.333,537.892,426.477z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 496.017,
    y: 369.745,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M537.897,408.208c0,0-0.016-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.317-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.061,0.055,0.489-0.49,0.257-0.254v0.01v0.021v0.041v0.082v0.164v0.328l0,0.655 v1.306c0,0.869,0,1.735,0,2.597c-0.001,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.008,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.659,0.026,6.548,0.046,8.552,0.06c0.973,0.012,1.731,0.02,2.272,0.027c0.244,0.005,0.436,0.01,0.59,0.013 C537.823,408.199,537.893,408.203,537.897,408.208c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.531,0.006-1.273,0.015-2.227,0.027c-1.991,0.014-4.863,0.034-8.5,0.06c-7.383,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c-0.001-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597v-1.306l0-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.87-0.019,1.546-0.026,2.032 C537.914,407.985,537.897,408.208,537.897,408.208z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.265,
    y: 370.463,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.265,
    y: 398.129,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M537.892,387.844c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 c0-0.144,9.511-0.26,21.247-0.26C528.379,387.584,537.892,387.701,537.892,387.844z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 489.882,
    y: 446.325,
    style: {
      fill: "#E0E0E0"
    },
    width: 95.29,
    height: 5.487
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 490.031,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 533.296,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 576.71,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 639.516,
    y: 408.378,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M681.396,446.841c0,0-0.016-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.318-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.061,0.055,0.489-0.49,0.257-0.254v0.01v0.021v0.041v0.082v0.164v0.328v0.655 l0,1.306c0,0.869,0,1.735,0,2.597c-0.001,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.008,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.66,0.026,6.548,0.046,8.552,0.06c0.973,0.011,1.731,0.02,2.272,0.027c0.244,0.005,0.436,0.01,0.59,0.013 C681.321,446.832,681.391,446.836,681.396,446.841c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.53,0.006-1.273,0.015-2.227,0.027c-1.991,0.014-4.863,0.034-8.5,0.06c-7.383,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c0-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597v-1.306l0-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.869-0.019,1.546-0.026,2.032 C681.412,446.618,681.396,446.841,681.396,446.841z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.764,
    y: 409.096,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.764,
    y: 436.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M681.391,426.477c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 s9.511-0.26,21.247-0.26C671.878,426.217,681.391,426.333,681.391,426.477z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 595.573,
    y: 408.378,
    style: {
      fill: "#F5F5F5"
    },
    width: 41.88,
    height: 38.463
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M637.452,446.841c0,0-0.016-0.256-0.025-0.728c-0.006-0.496-0.015-1.187-0.026-2.074 c-0.013-1.833-0.033-4.474-0.058-7.825c-0.028-6.734-0.067-16.318-0.114-27.835l0.222,0.222 c-12.092,0.011-26.477,0.024-41.876,0.038c-0.062,0.055,0.489-0.49,0.256-0.254v0.01v0.021v0.041v0.082v0.164v0.328v0.655 l0,1.306c0,0.869,0,1.735,0,2.597c0,1.724-0.001,3.432-0.002,5.124c-0.002,3.383-0.004,6.696-0.006,9.924 c-0.008,6.454-0.016,12.566-0.024,18.203l-0.228-0.228c12.474,0.048,22.911,0.087,30.259,0.116 c3.659,0.026,6.548,0.046,8.552,0.06c0.973,0.011,1.731,0.02,2.272,0.027c0.243,0.005,0.436,0.01,0.589,0.013 C637.378,446.832,637.448,446.836,637.452,446.841c0.004,0.004-0.057,0.009-0.182,0.013c-0.147,0.003-0.331,0.008-0.565,0.013 c-0.53,0.006-1.273,0.015-2.227,0.027c-1.992,0.014-4.863,0.034-8.5,0.06c-7.383,0.028-17.871,0.068-30.405,0.116 l-0.228,0.001l0-0.229c-0.007-5.637-0.015-11.749-0.024-18.203c-0.002-3.228-0.004-6.542-0.006-9.924 c0-1.691-0.001-3.4-0.002-5.124c0-0.862,0-1.728,0-2.597l0-1.306v-0.655v-0.328v-0.164v-0.082v-0.041v-0.021v-0.01 c-0.233,0.229,0.316-0.325,0.264-0.267c15.399,0.014,29.784,0.027,41.876,0.038l0.223,0l-0.001,0.222 c-0.047,11.576-0.086,21.207-0.114,27.975c-0.025,3.33-0.044,5.954-0.058,7.775c-0.011,0.869-0.02,1.546-0.026,2.032 C637.469,446.618,637.452,446.841,637.452,446.841z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.82,
    y: 409.096,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.82,
    y: 436.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.703,
    height: 9.629
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M637.447,426.477c0,0.144-9.513,0.26-21.245,0.26c-11.736,0-21.247-0.117-21.247-0.26 s9.511-0.26,21.247-0.26C627.934,426.217,637.447,426.333,637.447,426.477z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 589.438,
    y: 446.325,
    style: {
      fill: "#E0E0E0"
    },
    width: 95.29,
    height: 5.487
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 589.587,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 632.852,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 676.266,
    y: 451.812,
    style: {
      fill: "#E0E0E0"
    },
    width: 8.462,
    height: 6.446
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M367.788,90.169c-1.149-3.068-2.322-6.18-4.255-8.826c-1.933-2.646-4.759-4.813-8.011-5.211 c-3.252-0.398-6.856,1.357-7.916,4.458c-0.467-6.987-1.457-14.157-4.955-20.224c-3.498-6.067-10.024-10.833-17.014-10.406 c-6.591,0.403-12.234,5.299-15.37,11.11c-3.135,5.811-4.212,12.477-5.241,18.999c-2.498-3.066-7.774-2.102-10.381,0.872 c-2.608,2.973-3.268,7.13-3.823,11.045h78.641L367.788,90.169z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M226.996,52.487c-0.599-1.599-1.21-3.221-2.218-4.6c-1.008-1.379-2.48-2.508-4.175-2.716 c-1.695-0.208-3.573,0.707-4.126,2.323c-0.243-3.642-0.759-7.378-2.582-10.54c-1.823-3.162-5.224-5.646-8.867-5.423 c-3.435,0.21-6.376,2.762-8.01,5.79c-1.634,3.029-2.195,6.503-2.732,9.902c-1.302-1.598-4.051-1.096-5.41,0.454 c-1.359,1.55-1.703,3.716-1.992,5.757h40.986L226.996,52.487z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M77.013,107.986c-0.599-1.599-1.21-3.221-2.218-4.6c-1.008-1.379-2.48-2.508-4.175-2.716 c-1.695-0.208-3.573,0.707-4.126,2.324c-0.243-3.642-0.759-7.378-2.582-10.54c-1.823-3.162-5.224-5.646-8.867-5.423 c-3.435,0.21-6.376,2.762-8.01,5.79c-1.634,3.029-2.195,6.503-2.732,9.902c-1.302-1.598-4.051-1.095-5.41,0.454 c-1.359,1.55-1.703,3.716-1.992,5.757h40.986L77.013,107.986z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M628.662,48.208c-0.599-1.599-1.21-3.221-2.218-4.6c-1.008-1.379-2.48-2.508-4.175-2.716 c-1.695-0.208-3.573,0.707-4.126,2.324c-0.243-3.642-0.759-7.378-2.582-10.54c-1.823-3.162-5.224-5.646-8.867-5.423 c-3.435,0.21-6.376,2.762-8.01,5.79c-1.634,3.029-2.195,6.503-2.732,9.902c-1.302-1.598-4.052-1.096-5.41,0.454 c-1.359,1.55-1.703,3.716-1.992,5.757h40.986L628.662,48.208z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M227.126,71.353l0.646,1.603c5.447,13.514,3.39,28.151-5.78,37.823 c-1.179,1.243-2.459,2.394-3.834,3.436c-9.904,7.504-24.444,9.162-37.277,4.249c-7.547-2.89-14.816-7.943-22.605-8.05 c-10.137-0.14-17.16,8.003-22.912,15.511c-5.752,7.507-12.804,15.637-22.945,15.453c-6.351-0.115-12.614-3.644-17.56-8.126 c-13.093-11.864-18.259-30.423-15.389-46.257c2.871-15.834,12.839-29.056,25.275-38.738c17.42-13.564,40.688-20.95,64.345-17.432 C192.747,34.342,216.298,49.684,227.126,71.353z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M569.589,444.851l-1.332-1.101c-11.232-9.281-16.404-23.128-12.956-36.002 c0.443-1.655,1.02-3.277,1.732-4.849c5.127-11.319,17.117-19.709,30.74-21.51c8.012-1.059,16.81-0.083,23.708-3.703 c8.977-4.711,11.266-15.218,12.743-24.559c1.476-9.342,3.798-19.85,12.799-24.524c5.638-2.927,12.826-2.812,19.31-1.231 c17.166,4.185,30.557,18.034,35.584,33.321c5.027,15.287,2.57,31.662-3.744,46.102c-8.844,20.23-25.774,37.817-48.245,46.005 C617.456,460.989,589.44,458.734,569.589,444.851z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 40.161 233.0649)",
    style: {
      fill: "#F5F5F5"
    },
    cx: 301.415,
    cy: 68.054,
    rx: 28.728,
    ry: 28.728
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -158.4655 452.4922)",
    style: {
      fill: "#F5F5F5"
    },
    cx: 466.974,
    cy: 417.531,
    rx: 28.728,
    ry: 28.728
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M742.526,302.158c0,0.144-164.56,0.26-367.508,0.26c-203.019,0-367.544-0.117-367.544-0.26 c0-0.144,164.525-0.26,367.544-0.26C577.966,301.898,742.526,302.014,742.526,302.158z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Building"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.495,
    y: 199.327,
    style: {
      fill: "#FF725E"
    },
    width: 34.103,
    height: 5.096
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.086,
    y: 266.158,
    style: {
      fill: "#E0E0E0"
    },
    width: 42.309,
    height: 35.925
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "394.95,119.691 65.009,166.183 65.009,302.083 394.95,302.083 724.891,302.083  724.891,166.183  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.009,
    y: 266.158,
    width: 659.881,
    height: 35.925
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "65.009,181.736 398.282,133.839 724.891,176.886 724.891,166.183 397.676,119.691 65.009,166.183  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF725E"
    },
    points: "397.175,113.557 55.456,161.396 55.827,169.203 397.175,123.777 734.371,169.203  734.444,160.686  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.524,
    y: 208.01,
    style: {
      fill: "#263238"
    },
    width: 88.499,
    height: 94.073
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 526.829,
    y: 208.01,
    style: {
      fill: "#263238"
    },
    width: 88.499,
    height: 94.073
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.524,
    y: 208.01,
    style: {
      fill: "#FF725E"
    },
    width: 88.499,
    height: 13.964
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.144,302.083 173.144,214.486 255.046,214.486 255.046,208.01 166.547,208.01 166.547,302.083  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "533.426,302.083 533.426,214.486 615.328,214.486 615.328,208.01 526.829,208.01 526.829,302.083  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 346.677,
    y: 208.01,
    style: {
      fill: "#FF725E"
    },
    width: 88.499,
    height: 94.073
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 358.201,
    y: 274.306,
    style: {
      fill: "#263238"
    },
    width: 17.143,
    height: 10.199
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 383.808,
    y: 274.306,
    style: {
      fill: "#263238"
    },
    width: 17.143,
    height: 10.199
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 409.415,
    y: 274.306,
    style: {
      fill: "#263238"
    },
    width: 17.143,
    height: 10.199
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "353.274,302.083 353.274,214.486 435.176,214.486 435.176,208.01 346.677,208.01 346.677,302.083  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,213.597c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,213.337,435.176,213.453,435.176,213.597z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,219.002c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,218.742,435.176,218.858,435.176,219.002z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,224.407c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,224.147,435.176,224.264,435.176,224.407z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,229.812c0,0.144-19.789,0.261-44.193,0.261c-24.413,0-44.198-0.117-44.198-0.261 c0-0.144,19.784-0.26,44.198-0.26C415.387,229.552,435.176,229.669,435.176,229.812z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,235.218c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,234.957,435.176,235.074,435.176,235.218z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,240.623c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,240.362,435.176,240.479,435.176,240.623z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,246.028c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,245.768,435.176,245.884,435.176,246.028z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,251.433c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,251.173,435.176,251.289,435.176,251.433z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,256.838c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.116-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,256.578,435.176,256.695,435.176,256.838z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,262.243c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,261.983,435.176,262.1,435.176,262.243z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,267.649c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,267.388,435.176,267.505,435.176,267.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,273.054c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,272.793,435.176,272.91,435.176,273.054z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,278.232c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 c0-0.144,19.784-0.26,44.198-0.26C415.387,277.972,435.176,278.089,435.176,278.232z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,283.411c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,283.15,435.176,283.267,435.176,283.411z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,288.589c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,288.329,435.176,288.445,435.176,288.589z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,293.767c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,293.507,435.176,293.624,435.176,293.767z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M435.176,298.946c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.198-0.117-44.198-0.26 s19.784-0.26,44.198-0.26C415.387,298.685,435.176,298.802,435.176,298.946z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M254.969,217.379c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.197-0.117-44.197-0.26 c0-0.144,19.784-0.26,44.197-0.26C235.181,217.118,254.969,217.235,254.969,217.379z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M254.969,211.86c0,0.144-19.789,0.26-44.193,0.26c-24.413,0-44.197-0.117-44.197-0.26 s19.784-0.26,44.197-0.26C235.181,211.6,254.969,211.716,254.969,211.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.699,
    y: 271.783,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.858,
    y: 273.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 205.699,
    y: 271.783,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.858,284.423c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 s0.26,2.849,0.26,6.364C224.119,281.574,224.002,284.423,223.858,284.423z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.57,
    y: 271.783,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.57,
    y: 281.879,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.314,
    y: 258.909,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.474,
    y: 260.551,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.314,
    y: 258.909,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M193.474,271.548c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C193.734,268.699,193.618,271.548,193.474,271.548z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.186,
    y: 258.909,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.461,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.186,
    y: 269.005,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.461,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.904,
    y: 271.681,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.064,
    y: 273.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174.904,
    y: 271.681,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M193.064,284.321c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C193.324,281.472,193.208,284.321,193.064,284.321z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.776,
    y: 271.681,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.776,
    y: 281.777,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.387,
    y: 271.789,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.546,
    y: 273.432,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.387,
    y: 271.789,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M211.546,284.429c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C211.807,281.58,211.69,284.429,211.546,284.429z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.258,
    y: 271.789,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.258,
    y: 281.885,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.867,
    y: 284.764,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.027,
    y: 286.407,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 174.867,
    y: 284.764,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M193.027,297.404c-0.144,0-0.26-2.849-0.26-6.364c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C193.287,294.555,193.171,297.404,193.027,297.404z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.739,
    y: 284.764,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.739,
    y: 294.86,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 2.922
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.32,
    y: 284.846,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.479,
    y: 286.488,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 193.32,
    y: 284.846,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M211.479,297.486c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C211.74,294.636,211.623,297.486,211.479,297.486z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.191,
    y: 284.846,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.461,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.191,
    y: 294.942,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.461,
    height: 2.928
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.915,
    y: 284.845,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.074,
    y: 286.487,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 211.915,
    y: 284.845,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.074,297.484c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C230.335,294.635,230.218,297.484,230.074,297.484z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.786,
    y: 284.845,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.786,
    y: 294.941,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 2.858
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.548,
    y: 258.915,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.708,
    y: 260.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 205.548,
    y: 258.915,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.708,271.555c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 s0.26,2.849,0.26,6.364C223.968,268.705,223.852,271.555,223.708,271.555z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.42,
    y: 258.915,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.42,
    y: 269.011,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M241.846,284.778c0,0.144-14.929,0.26-33.341,0.26c-18.418,0-33.344-0.117-33.344-0.26 s14.926-0.26,33.344-0.26C226.917,284.517,241.846,284.634,241.846,284.778z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M236.336,271.577c0,0.144-13.696,0.26-30.586,0.26c-16.896,0-30.589-0.117-30.589-0.26 s13.693-0.26,30.589-0.26C222.641,271.317,236.336,271.434,236.336,271.577z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 205.499,
    y: 258.905,
    width: 1.877,
    height: 12.643
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.276,
    y: 297.782,
    style: {
      fill: "#AE7461"
    },
    width: 38.976,
    height: 2.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.337,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 174.337,
    y: 300.026,
    width: 3.461,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.034,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 192.034,
    y: 300.026,
    width: 3.461,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.791,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 209.791,
    y: 300.026,
    width: 3.461,
    height: 0.637
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.656,
    y: 297.782,
    style: {
      fill: "#AE7461"
    },
    width: 38.976,
    height: 2.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.717,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 213.717,
    y: 300.026,
    width: 3.461,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.414,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 231.414,
    y: 300.026,
    width: 3.461,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.171,
    y: 300.026,
    style: {
      fill: "#AE7461"
    },
    width: 3.461,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 249.171,
    y: 300.026,
    width: 3.461,
    height: 0.637
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.005,
    y: 253.632,
    style: {
      fill: "#455A64"
    },
    width: 10.682,
    height: 19.422
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.243,
    y: 253.632,
    style: {
      fill: "#455A64"
    },
    width: 10.682,
    height: 19.422
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 621.624,
    y: 253.632,
    style: {
      fill: "#455A64"
    },
    width: 10.682,
    height: 19.422
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.352,
    y: 244.731,
    style: {
      fill: "#FF725E"
    },
    width: 30.495,
    height: 57.351
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.28,302.083 103.28,247.57 130.847,247.57 130.847,244.731 100.352,244.731 100.352,302.083  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 672.672,
    y: 244.731,
    style: {
      fill: "#FF725E"
    },
    width: 30.495,
    height: 57.351
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "675.6,302.083 675.6,247.57 703.168,247.57 703.168,244.731 672.672,244.731 672.672,302.083  "
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 59.857,
    y: 266.158,
    width: 5.152,
    height: 35.925
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M64.809,302.083c-0.144,0-0.26-29.718-0.26-66.369c0-36.663,0.117-66.375,0.26-66.375 c0.144,0,0.26,29.712,0.26,66.375C65.069,272.365,64.953,302.083,64.809,302.083z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.126,
    y: 249.469,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.285,
    y: 251.111,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 29.126,
    y: 249.469,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M47.285,262.108c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C47.546,259.259,47.429,262.108,47.285,262.108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.997,
    y: 249.469,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.997,
    y: 259.565,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.126,
    y: 236.48,
    style: {
      fill: "#FF725E"
    },
    width: 30.234,
    height: 13.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.285,
    y: 238.122,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.48,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 29.126,
    y: 236.48,
    width: 18.16,
    height: 13.024
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M47.285,249.12c-0.144,0-0.26-2.849-0.26-6.363c0-3.515,0.117-6.364,0.26-6.364 c0.144,0,0.26,2.849,0.26,6.364C47.546,246.27,47.429,249.12,47.285,249.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.997,
    y: 236.48,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.997,
    y: 246.576,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.462,
    height: 3.003
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M29.014,249.469c0-0.144,6.724-0.26,15.018-0.26c8.296,0,15.019,0.117,15.019,0.26 s-6.723,0.26-15.019,0.26C35.738,249.729,29.014,249.612,29.014,249.469z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.089,
    y: 261.277,
    style: {
      fill: "#AE7461"
    },
    width: 32.308,
    height: 2.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.139,
    y: 263.521,
    style: {
      fill: "#AE7461"
    },
    width: 2.869,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 28.139,
    y: 263.521,
    width: 2.869,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.808,
    y: 263.521,
    style: {
      fill: "#AE7461"
    },
    width: 2.869,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 42.808,
    y: 263.521,
    width: 2.869,
    height: 0.637
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.528,
    y: 263.521,
    style: {
      fill: "#AE7461"
    },
    width: 2.869,
    height: 2.636
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 57.528,
    y: 263.521,
    width: 2.869,
    height: 0.637
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M267.261,302.507h-4.164V282.14c0-1.067,0.865-1.932,1.932-1.932h0.301 c1.067,0,1.932,0.865,1.932,1.932V302.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M158.893,302.507h-4.164V282.14c0-1.067,0.865-1.932,1.932-1.932h0.301 c1.067,0,1.932,0.865,1.932,1.932V302.507z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M339.062,302.507h-4.164V282.14c0-1.067,0.865-1.932,1.932-1.932h0.301 c1.067,0,1.932,0.865,1.932,1.932V302.507z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M627.599,302.507h-4.164V282.14c0-1.067,0.865-1.932,1.932-1.932h0.301 c1.067,0,1.932,0.865,1.932,1.932V302.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M519.231,302.507h-4.164V282.14c0-1.067,0.865-1.932,1.932-1.932h0.301 c1.067,0,1.932,0.865,1.932,1.932V302.507z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 377.698,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.233,180.642c-0.506,0-17.535,15.928-17.535,15.928h6.468l18.267-15.928H395.233z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.431,196.57c0,0,17.681-15.928,17.914-15.928c0.233,0,2.199,0,2.199,0v1.829l-17.01,14.099 H388.431z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.813,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.875,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.41,180.642c-0.506,0-17.535,15.928-17.535,15.928h6.468l18.268-15.928H216.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.796,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.331,180.642c-0.506,0-17.535,15.928-17.535,15.928h6.468l18.267-15.928H120.331z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M113.529,196.57c0,0,17.681-15.928,17.914-15.928c0.233,0,2.199,0,2.199,0v1.829l-17.01,14.099 H113.529z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 476.83,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.163,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M588.698,180.642c-0.506,0-17.535,15.928-17.535,15.928h6.468l18.267-15.928H588.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 663.185,
    y: 180.642,
    style: {
      fill: "#455A64"
    },
    width: 30.845,
    height: 15.928
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M680.72,180.642c-0.506,0-17.535,15.928-17.535,15.928h6.468l18.268-15.928H680.72z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M673.918,196.57c0,0,17.681-15.928,17.914-15.928c0.233,0,2.199,0,2.199,0v1.829l-17.01,14.099 H673.918z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 262.005,
    y: 239.499,
    width: 10.128,
    height: 10.128
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 446.52,
    y: 239.499,
    width: 10.128,
    height: 10.128
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 621.901,
    y: 239.499,
    width: 10.128,
    height: 10.128
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 537.822,
    y: 217.847,
    style: {
      fill: "#E0E0E0"
    },
    width: 68.742,
    height: 75.133
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M606.564,292.981c0,0-0.009-0.127-0.013-0.363c-0.003-0.25-0.007-0.597-0.013-1.048 c-0.006-0.936-0.015-2.294-0.027-4.059c-0.014-3.557-0.034-8.741-0.06-15.325c-0.028-13.165-0.068-31.919-0.116-54.338 l0.228,0.228c-20.154,0.009-43.697,0.02-68.734,0.032h-0.007l0.26-0.26c-0.014,27.641-0.027,53.456-0.038,75.133l-0.222-0.222 c20.635,0.047,37.791,0.086,49.806,0.114c6.008,0.025,10.727,0.044,13.964,0.058c1.605,0.011,2.838,0.02,3.69,0.026 C606.119,292.964,606.564,292.981,606.564,292.981s-0.411,0.017-1.234,0.025c-0.842,0.006-2.061,0.014-3.647,0.026 c-3.225,0.013-7.927,0.033-13.914,0.058c-12.049,0.027-29.254,0.067-49.947,0.114l-0.222,0.001l0-0.222 c-0.011-21.677-0.024-47.492-0.039-75.133l0-0.26h0.261h0.007c25.037,0.012,48.581,0.022,68.734,0.032l0.229,0l0,0.228 c-0.048,22.48-0.088,41.284-0.116,54.485c-0.026,6.562-0.046,11.728-0.06,15.273c-0.011,1.746-0.021,3.089-0.027,4.014 c-0.006,0.441-0.01,0.779-0.013,1.023C606.572,292.871,606.564,292.981,606.564,292.981z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M544.504,283.89l-0.273-0.07c-0.164-0.176-3.284-4.009-5.961-7.323 c-5.821-7.209-5.807-7.244-5.723-7.438l0.231-0.151v0.25l0.226-0.099c0.359,0.65,11.503,14.323,11.593,14.42l-0.181,0.167 L544.504,283.89z M532.779,269.159v0.248V269.159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M545.656,279.421l-0.271-0.073c-0.167-0.181-3.093-3.771-5.973-7.339 c-5.809-7.193-5.793-7.228-5.708-7.422l0.23-0.15v0.25l0.226-0.099c0.363,0.657,11.503,14.324,11.592,14.421l-0.18,0.167 L545.656,279.421z M533.934,264.689v0.248V264.689z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M533.359,274.67h-1.316c-1.651,0-2.99-1.339-2.99-2.99v-9.657c0-1.651,1.338-2.99,2.99-2.99 h1.316c1.651,0,2.99,1.338,2.99,2.99v9.657C536.349,273.332,535.01,274.67,533.359,274.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M601.346,283.89l0.084-0.235l-0.178-0.176c0.09-0.097,11.233-13.77,11.593-14.42l0.204,0.113 l0.021-0.013v-0.252l0.232,0.151c0.084,0.193,0.099,0.229-5.723,7.438c-2.677,3.315-5.797,7.147-5.961,7.323L601.346,283.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M600.192,279.42l0.084-0.235l-0.178-0.176c0.09-0.097,11.233-13.771,11.593-14.421l0.204,0.113 l0.021-0.013v-0.252l0.232,0.151c0.084,0.193,0.099,0.229-5.723,7.438c-2.677,3.315-5.797,7.148-5.961,7.324L600.192,279.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M612.491,274.67h1.316c1.651,0,2.99-1.339,2.99-2.99v-9.657c0-1.651-1.338-2.99-2.99-2.99h-1.316 c-1.651,0-2.99,1.338-2.99,2.99v9.657C609.501,273.332,610.84,274.67,612.491,274.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 536.947,
    y: 304.032,
    style: {
      fill: "#263238"
    },
    width: 11.078,
    height: 20.244
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 598.352,
    y: 304.032,
    style: {
      fill: "#263238"
    },
    width: 11.594,
    height: 20.244
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M549.965,245.341c-1.519,0.021-2.926,0.784-3.788,2.035c-0.477,0.693-0.928,1.463-1.129,2.136 c-0.522,1.74-3.379,6.551-5.642,23.608c-0.83,5.245-1.501,11.292-2.089,17.753l-0.696,6.075l72.504,0.302 c0,0-2.082-20.613-2.563-24.137c-0.48-3.523-6.086-25.212-6.086-25.212s0.16-1.855-3.684-2.529 C593.462,244.788,559.075,245.217,549.965,245.341z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "553.437,284.2 592.74,284.2 607.708,283.02 609.125,296.878 592.021,297.25 536.621,296.949 537.49,289.013  538.103,283.02  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M547.007,254.854c0,0-2.914,0.112-4.035,5.604c-1.121,5.492-2.017,14.346-2.017,14.346h64.221 l-3.25-15.915c0,0-0.439-2.712-4.147-4.035C594.046,253.522,548.601,253.34,547.007,254.854z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M577.062,256.441h-8.412c-1.059,0-1.918-0.859-1.918-1.918v-0.726h12.248v0.726 C578.98,255.583,578.121,256.441,577.062,256.441z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "540.955,274.804 541.211,272.459 604.546,272.459 605.175,274.804  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M600.45,273.23h-0.407c0-3.292-2.679-5.971-5.971-5.971s-5.971,2.679-5.971,5.971h-0.407 c0-3.517,2.861-6.378,6.378-6.378S600.45,269.713,600.45,273.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M586.135,272.821c0,0,0.884-1.642,3.452-1.711c2.384-0.064,8.435,0.003,8.435,0.003 s2.954,0.129,3.808,1.346v0.772h-15.695V272.821z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M545.248,272.883c-0.258,0.325,0.123-4.789,0.709-7.034c0.135-0.517,0.601-0.877,1.136-0.877 h10.463c0.578,0,1.07,0.42,1.159,0.991c0.239,1.545,0.881,4.51,1.027,6.935L545.248,272.883z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M555.242,264.295h-5.655c-0.985,0-1.783-0.799-1.783-1.784v-1.35 c0-0.985,0.799-1.783,1.783-1.783h5.655c0.985,0,1.783,0.799,1.783,1.783v1.35 C557.025,263.496,556.227,264.295,555.242,264.295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M563.899,272.883c-0.258,0.325,0.124-4.789,0.709-7.034c0.135-0.517,0.601-0.877,1.136-0.877 h10.463c0.578,0,1.07,0.42,1.159,0.991c0.239,1.545,0.881,4.51,1.027,6.935L563.899,272.883z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M573.893,264.295h-5.655c-0.985,0-1.783-0.799-1.783-1.784v-1.35 c0-0.985,0.798-1.783,1.783-1.783h5.655c0.985,0,1.783,0.799,1.783,1.783v1.35 C575.677,263.496,574.878,264.295,573.893,264.295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M583.153,272.883c-0.258,0.325,0.123-4.789,0.709-7.034c0.135-0.517,0.601-0.877,1.136-0.877 h10.463c0.578,0,1.07,0.42,1.159,0.991c0.239,1.545,0.881,4.51,1.027,6.935L583.153,272.883z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M593.147,264.295h-5.655c-0.985,0-1.783-0.799-1.783-1.783v-1.35 c0-0.985,0.799-1.783,1.783-1.783h5.655c0.985,0,1.783,0.798,1.783,1.783v1.35 C594.931,263.496,594.132,264.295,593.147,264.295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M605.175,274.804c0,0,0.005,0.085,0.003,0.251c-0.003,0.174-0.008,0.418-0.014,0.736 c-0.018,0.655-0.043,1.606-0.075,2.828c-0.075,2.463-0.184,6.014-0.318,10.397l-0.002,0.074l-0.074,0 c-8.173,0.008-19.318,0.018-31.59,0.029c-12.535-0.012-23.891-0.023-32.15-0.031l-0.076,0l0-0.075 c0.014-4.215,0.026-7.628,0.034-9.996c0.009-1.174,0.015-2.088,0.02-2.717c0.005-0.305,0.008-0.539,0.011-0.707 c0.004-0.159,0.011-0.241,0.011-0.241s0.007,0.081,0.011,0.241c0.003,0.167,0.006,0.402,0.011,0.707 c0.005,0.63,0.011,1.544,0.02,2.717c0.008,2.368,0.02,5.781,0.034,9.996l-0.076-0.076c8.258-0.008,19.615-0.019,32.15-0.031 c12.272,0.011,23.417,0.022,31.59,0.029l-0.077,0.074c0.163-4.382,0.295-7.932,0.386-10.395 c0.05-1.221,0.089-2.172,0.116-2.826c0.016-0.317,0.027-0.561,0.036-0.735C605.165,274.889,605.175,274.804,605.175,274.804z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M592.74,284.2c-0.078,0.233,0,7.84,0,7.84s12.819,0.697,15.685-2.484l-0.718-6.535 L592.74,284.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M592.74,284.2c-0.003-0.005,0.09-0.017,0.274-0.036c0.199-0.019,0.47-0.045,0.814-0.078 c0.732-0.064,1.775-0.156,3.082-0.271c2.667-0.221,6.412-0.531,10.79-0.894l0.096-0.008l0.011,0.096 c0.224,2.025,0.469,4.234,0.724,6.534l0.005,0.049l-0.032,0.033c-0.278,0.287-0.613,0.556-0.985,0.762 c-1.285,0.717-2.694,1.015-4.035,1.264c-1.351,0.23-2.67,0.355-3.934,0.435c-2.529,0.149-4.836,0.128-6.813,0.032 l-0.075-0.004l0-0.075c-0.014-2.415-0.013-4.376,0.001-5.732c0.007-0.678,0.016-1.206,0.031-1.563 C592.701,284.391,592.733,284.192,592.74,284.2c0.001,0.283,0.004,0.878,0.01,2.108c0.017,1.372,0.04,3.327,0.07,5.731 l-0.075-0.079c1.969,0.079,4.274,0.087,6.792-0.071c1.258-0.084,2.572-0.212,3.911-0.442 c1.328-0.248,2.725-0.549,3.965-1.242c0.359-0.199,0.674-0.454,0.934-0.72l-0.026,0.082c-0.25-2.301-0.491-4.511-0.711-6.536 l0.107,0.088c-4.36,0.326-8.09,0.605-10.746,0.803c-1.316,0.092-2.365,0.165-3.103,0.217 c-0.352,0.022-0.629,0.039-0.832,0.052c-0.087,0.004-0.158,0.007-0.217,0.01C592.768,284.203,592.742,284.202,592.74,284.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M553.2,284.2c0.078,0.233,0,7.84,0,7.84s-12.818,0.697-15.685-2.484l0.717-6.535L553.2,284.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M553.2,284.2c-0.002,0.002-0.028,0.003-0.077,0.001c-0.059-0.003-0.13-0.006-0.217-0.01 c-0.204-0.013-0.48-0.03-0.832-0.052c-0.737-0.052-1.787-0.125-3.103-0.217c-2.657-0.199-6.386-0.477-10.746-0.803 l0.107-0.088c-0.22,2.025-0.461,4.234-0.711,6.536l-0.027-0.082c0.26,0.266,0.575,0.521,0.934,0.72 c1.239,0.693,2.637,0.994,3.965,1.242c1.339,0.23,2.653,0.358,3.911,0.442c2.518,0.158,4.823,0.15,6.792,0.071l-0.075,0.079 c0.029-2.403,0.053-4.359,0.07-5.731C553.195,285.078,553.198,284.483,553.2,284.2c0.007-0.008,0.039,0.191,0.048,0.545 c0.015,0.358,0.024,0.885,0.031,1.563c0.014,1.357,0.015,3.317,0.001,5.732l0,0.075l-0.075,0.004 c-1.977,0.096-4.284,0.117-6.813-0.032c-1.264-0.08-2.583-0.205-3.934-0.435c-1.341-0.249-2.75-0.547-4.035-1.264 c-0.372-0.207-0.707-0.475-0.985-0.762l-0.032-0.033l0.005-0.049c0.255-2.301,0.5-4.51,0.724-6.534l0.011-0.096l0.096,0.008 c4.378,0.363,8.122,0.673,10.79,0.894c1.307,0.115,2.35,0.207,3.082,0.271c0.344,0.033,0.615,0.059,0.814,0.078 C553.11,284.184,553.203,284.196,553.2,284.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M536.621,296.949c0,0-0.708,9.475,0.923,15.233c0.526,1.857,2.233,3.128,4.163,3.128h63.801 c1.384,0,2.63-0.844,3.129-2.135c1.012-2.617,2.1-7.029,0.488-16.297l-18.876,0.071H536.621z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.405,300.054c0.202,0.135,0.808,4.26,3.704,4.866c2.896,0.606,7.744,0.269,7.744,0.269v-5.135H538.405z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M547.416,302.613c0,1.292-1.048,2.34-2.34,2.34c-1.292,0-2.34-1.048-2.34-2.34 c0-1.292,1.048-2.34,2.34-2.34C546.368,300.273,547.416,301.32,547.416,302.613z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M605.023,300.111c-0.202,0.135-0.808,4.26-3.704,4.866c-2.896,0.606-7.744,0.269-7.744,0.269v-5.135H605.023z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M596.013,302.669c0,1.292,1.048,2.34,2.34,2.34c1.292,0,2.34-1.048,2.34-2.34 c0-1.292-1.048-2.34-2.34-2.34C597.06,300.329,596.013,301.376,596.013,302.669z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M555.366,300.054v4.022c0,2.172,1.761,3.933,3.933,3.933h27.306 c2.172,0,3.933-1.761,3.933-3.933v-3.804L555.366,300.054z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M586.604,306.419h-27.306c-2.172,0-3.933-1.761-3.933-3.933v1.66c0,2.172,1.761,3.933,3.933,3.933h27.306 c2.172,0,3.933-1.761,3.933-3.933v-1.66C590.537,304.659,588.776,306.419,586.604,306.419z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M557.518,289.013c0,0-1.848,0.744-2.152,3.563c-0.371,3.441,3.562,4.373,3.562,4.373h29.903 c0,0,1.632-1.85,1.707-4.373c0.074-2.523-2.3-3.563-2.3-3.563H557.518z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M609.125,296.878c0,0,0.31,1.442,0.614,4.09c0.143,1.324,0.283,2.952,0.257,4.848 c-0.027,1.889-0.209,4.068-0.925,6.354c-0.094,0.284-0.188,0.571-0.297,0.857c-0.101,0.287-0.232,0.582-0.412,0.844 c-0.354,0.53-0.87,0.97-1.481,1.234c-0.305,0.133-0.633,0.222-0.969,0.262c-0.341,0.04-0.675,0.023-1.012,0.027 c-0.675,0.001-1.363,0.002-2.063,0.003c-2.8,0.003-5.79,0.006-8.938,0.01c-6.295,0.003-13.215,0.005-20.479,0.008 c-7.266-0.003-14.188-0.006-20.484-0.008c-3.148-0.003-6.139-0.007-8.939-0.01c-0.7-0.001-1.388-0.002-2.063-0.003 c-0.68,0.021-1.365-0.101-1.973-0.361c-1.221-0.526-2.118-1.584-2.46-2.745c-0.629-2.311-0.84-4.47-0.962-6.357 c-0.115-1.89-0.124-3.521-0.108-4.853c0.017-1.332,0.066-2.365,0.107-3.065c0.024-0.345,0.042-0.609,0.054-0.796 c0.015-0.179,0.029-0.27,0.029-0.27s0,0.092-0.007,0.272c-0.008,0.187-0.019,0.452-0.033,0.796 c-0.027,0.7-0.062,1.733-0.067,3.064c-0.003,1.33,0.017,2.959,0.143,4.844c0.133,1.88,0.356,4.036,0.987,6.32 c0.335,1.12,1.203,2.136,2.381,2.639c0.59,0.248,1.237,0.363,1.908,0.342c0.675-0.001,1.363-0.002,2.063-0.003 c2.8-0.003,5.791-0.006,8.939-0.01c6.296-0.003,13.218-0.005,20.484-0.008c7.264,0.003,14.184,0.006,20.479,0.008 c3.147,0.003,6.138,0.007,8.938,0.01c0.7,0.001,1.388,0.002,2.063,0.003c0.338-0.003,0.675,0.014,0.993-0.023 c0.321-0.037,0.633-0.121,0.924-0.247c0.583-0.25,1.076-0.667,1.416-1.172c0.174-0.252,0.296-0.524,0.399-0.811 c0.11-0.283,0.204-0.568,0.298-0.849c0.72-2.263,0.912-4.428,0.95-6.311c0.037-1.888-0.09-3.514-0.221-4.837 c-0.061-0.663-0.135-1.249-0.203-1.757c-0.061-0.509-0.125-0.938-0.18-1.284c-0.05-0.342-0.089-0.604-0.116-0.789 C609.133,296.97,609.125,296.878,609.125,296.878z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M609.125,296.878c0,0.059-15.314,0.106-34.202,0.106c-18.894,0-34.205-0.047-34.205-0.106 c0-0.059,15.311-0.106,34.205-0.106C593.811,296.772,609.125,296.819,609.125,296.878z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 441.386,
    y: 317.394,
    style: {
      fill: "#263238"
    },
    width: 4.476,
    height: 3.128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 441.386,
    y: 326.229,
    style: {
      fill: "#263238"
    },
    width: 4.476,
    height: 3.128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M474.388,314.64c0.291-0.298,0.286-0.776-0.012-1.067c-0.004-0.004-0.007-0.007-0.011-0.01 l-7.227-6.831c-0.3-0.281-0.766-0.281-1.066,0l0,0c-0.315,0.293-0.333,0.786-0.04,1.101c0.004,0.004,0.008,0.008,0.011,0.012 l2.882,3.031l-1.5,1.445l-0.781-0.621l-5.451,6.243l-2.913-2.802l-3.512,10.33l-0.36,13.663l9.121-0.081l-0.55-16.223l5.42-7.719 l0.042-1.836l1.558-1.596l3.359,3c0.303,0.27,0.764,0.253,1.046-0.038H474.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M469.017,338.487l4.915-13.655l-0.854-0.346c-0.6-0.243-0.993-0.826-0.993-1.474l0,0 c0-0.869,0.697-1.576,1.566-1.59l11.871-0.183c0.655-0.013,1.2-0.508,1.273-1.16l1.976-17.544 c0.092-0.812,0.779-1.426,1.596-1.427l0,0c0.886-0.001,1.605,0.717,1.606,1.603c0,0.023,0,0.046-0.001,0.068l-0.752,18.078 l7.016,0.038l0.238,3.296l-20.749,0.812l-5.411,13.286L469.017,338.487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M472.108,338.153l-17.468,0.138v1.164l7.236-0.093l11.525-0.089l27.942-3.944l-3.167-12.055 h-18.919c-0.664-0.01-1.29,0.308-1.674,0.85L472.108,338.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M464.309,287.625l-11.622,41.013l-1.548,10.861h4.022v-11.193l10.655-40.457l27.011,0.133 c0.33,0.002,0.609,0.246,0.654,0.573l5.662,41.278h3.181l-6.559-41.845c-0.213-1.129-1.199-1.947-2.348-1.948h-27.39 C464.971,286.04,463.938,286.041,464.309,287.625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M448.76,352.509v-10.817l2.368-2.192l22.258-0.287l4.006-3.259 c0.746-0.606,1.665-0.961,2.624-1.015l4.287-0.243c0,0,1.923-1.324,3.784-2.637c2.357-1.67,5.173-2.567,8.062-2.569h12.337 c0.933,0,1.689,0.756,1.689,1.689l0,0v21.33H448.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.542,
    y: 349.024,
    style: {
      fill: "#263238"
    },
    width: 61.629,
    height: 3.557
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M451.733,352.469c-0.062,4.209,3.299,7.671,7.508,7.733c4.208,0.062,7.671-3.299,7.733-7.508 c0.062-4.208-3.299-7.671-7.507-7.733c-0.001,0-0.002,0-0.003,0C455.256,344.901,451.796,348.262,451.733,352.469z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.485,342.807c-0.001,0-0.002,0-0.004,0c-5.318-0.077-9.841,4.456-9.92,9.774h19.412 C469.053,347.261,464.805,342.885,459.485,342.807z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496.482,342.807c-0.001,0-0.002,0-0.004,0c-5.318-0.077-9.841,4.456-9.92,9.774h19.412 C506.049,347.261,501.801,342.885,496.482,342.807z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M451.734,352.451c0,0,0,0.011,0,0.018c-0.024,4.209,3.368,7.64,7.577,7.665 c4.156,0.024,7.565-3.287,7.663-7.442c0,0,0-0.013,0-0.02L451.734,352.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M454.002,352.503c-0.038,2.95,2.323,5.372,5.273,5.41c2.95,0.038,5.372-2.323,5.41-5.273 c0.038-2.943-2.313-5.363-5.256-5.409c-2.95-0.047-5.379,2.306-5.426,5.256C454.002,352.491,454.002,352.497,454.002,352.503z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M459.428,347.23c-2.95-0.047-5.379,2.306-5.426,5.256c0,0.006,0,0.011,0,0.017l10.699,0.154 c0.047-2.95-2.306-5.379-5.256-5.426C459.439,347.23,459.434,347.23,459.428,347.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M456.092,352.534c-0.022,1.799,1.419,3.276,3.218,3.298c1.799,0.022,3.276-1.419,3.298-3.218 c0.022-1.799-1.419-3.276-3.218-3.298C457.591,349.294,456.115,350.734,456.092,352.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M489.022,352.469c-0.062,4.209,3.299,7.671,7.508,7.733c4.209,0.062,7.671-3.299,7.733-7.508 c0.062-4.208-3.299-7.671-7.508-7.733c-0.001,0-0.002,0-0.003,0C492.545,344.901,489.084,348.262,489.022,352.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M489.024,352.451c0,0,0,0.011,0,0.018c-0.024,4.209,3.369,7.64,7.578,7.664 c4.156,0.023,7.564-3.287,7.662-7.442c0,0,0-0.013,0-0.02L489.024,352.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M491.292,352.503c-0.038,2.95,2.323,5.372,5.273,5.41s5.372-2.323,5.41-5.273 c0.038-2.943-2.313-5.363-5.256-5.409c-2.95-0.047-5.379,2.306-5.426,5.256C491.293,352.491,491.292,352.497,491.292,352.503z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M496.719,347.23c-2.95-0.047-5.379,2.306-5.426,5.256c0,0.006,0,0.011,0,0.017l10.699,0.154 c0.047-2.95-2.306-5.379-5.256-5.426C496.73,347.23,496.724,347.23,496.719,347.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M493.385,352.534c-0.022,1.799,1.419,3.276,3.218,3.298c1.799,0.022,3.276-1.419,3.298-3.219 c0.022-1.797-1.415-3.272-3.211-3.298c-1.799-0.026-3.279,1.412-3.305,3.211C493.385,352.529,493.385,352.531,493.385,352.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.482,
    y: 285.729,
    style: {
      fill: "#263238"
    },
    width: 2.82,
    height: 56.018
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.179,
    y: 284.445,
    style: {
      fill: "#263238"
    },
    width: 5.756,
    height: 2.569
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.039,
    y: 341.285,
    style: {
      fill: "#263238"
    },
    width: 3.706,
    height: 7.394
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.057,
    y: 284.445,
    style: {
      fill: "#263238"
    },
    width: 3.875,
    height: 12.332
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 439.967,
    y: 290.819,
    style: {
      fill: "#263238"
    },
    width: 2.839,
    height: 40.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 418.934,
    y: 310.172,
    style: {
      fill: "#455A64"
    },
    width: 19.714,
    height: 18.106
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M438.649,328.278c-0.008-0.008-0.017-0.129-0.025-0.355c-0.007-0.264-0.015-0.589-0.026-0.988 c-0.014-0.906-0.034-2.145-0.058-3.697c-0.028-3.203-0.067-7.69-0.114-13.066l0.222,0.222 c-5.703,0.011-12.47,0.024-19.712,0.038c-0.059,0.056,0.491-0.492,0.259-0.257v0.005v0.01v0.019v0.039v0.077v0.154l0,0.308 l0,0.615c0,0.409,0,0.817,0,1.223c0,0.811-0.001,1.616-0.001,2.412c-0.002,1.592-0.004,3.152-0.006,4.672 c-0.008,3.036-0.016,5.912-0.024,8.569l-0.228-0.228c5.826,0.047,10.713,0.087,14.205,0.116 c1.697,0.025,3.052,0.045,4.039,0.06c0.438,0.011,0.794,0.02,1.081,0.027C438.508,328.26,438.64,328.269,438.649,328.278 c0.009,0.009-0.107,0.017-0.338,0.026c-0.275,0.007-0.616,0.016-1.037,0.027c-0.975,0.015-2.313,0.035-3.988,0.06 c-3.528,0.029-8.465,0.068-14.352,0.116l-0.228,0.002l-0.001-0.23c-0.007-2.657-0.015-5.533-0.024-8.569 c-0.002-1.52-0.004-3.08-0.006-4.672c0-0.796-0.001-1.601-0.001-2.412c0-0.406,0-0.813,0-1.223l0-0.615v-0.308v-0.154v-0.077 v-0.039v-0.019v-0.01v-0.005c-0.233,0.231,0.316-0.321,0.262-0.263c7.242,0.014,14.009,0.027,19.712,0.038l0.224,0 l-0.002,0.222c-0.047,5.434-0.086,9.968-0.114,13.206c-0.024,1.531-0.044,2.753-0.058,3.647 c-0.01,0.382-0.019,0.693-0.026,0.945C438.665,328.181,438.657,328.286,438.649,328.278z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.583,
    y: 310.51,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.583,
    y: 323.533,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.646,318.692c0,0.144-4.478,0.26-10.001,0.26c-5.525,0-10.002-0.117-10.002-0.26s4.477-0.26,10.002-0.26 C434.168,318.431,438.646,318.548,438.646,318.692z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 418.934,
    y: 291.986,
    style: {
      fill: "#455A64"
    },
    width: 19.714,
    height: 18.106
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M438.649,310.092c-0.008-0.008-0.017-0.129-0.025-0.356c-0.007-0.264-0.015-0.589-0.026-0.988 c-0.014-0.906-0.034-2.145-0.058-3.697c-0.028-3.203-0.067-7.69-0.114-13.065l0.222,0.222 c-5.703,0.011-12.47,0.024-19.712,0.038c-0.059,0.056,0.491-0.492,0.259-0.257v0.005v0.01v0.019v0.039v0.077v0.155l0,0.308 l0,0.615c0,0.409,0,0.817,0,1.223c0,0.811-0.001,1.616-0.001,2.412c-0.002,1.592-0.004,3.152-0.006,4.672 c-0.008,3.036-0.016,5.912-0.024,8.569l-0.228-0.228c5.826,0.047,10.713,0.087,14.205,0.116 c1.697,0.025,3.052,0.045,4.039,0.06c0.438,0.011,0.794,0.02,1.081,0.027C438.508,310.074,438.64,310.083,438.649,310.092 c0.009,0.009-0.107,0.017-0.338,0.026c-0.275,0.007-0.616,0.016-1.037,0.027c-0.975,0.015-2.313,0.035-3.988,0.06 c-3.528,0.028-8.465,0.068-14.352,0.116l-0.228,0.002l-0.001-0.23c-0.007-2.657-0.015-5.533-0.024-8.569 c-0.002-1.52-0.004-3.079-0.006-4.672c0-0.796-0.001-1.6-0.001-2.412c0-0.406,0-0.813,0-1.223l0-0.615v-0.308v-0.155v-0.077 v-0.039v-0.019v-0.01v-0.005c-0.233,0.231,0.316-0.321,0.262-0.263c7.242,0.014,14.009,0.027,19.712,0.038l0.224,0 l-0.002,0.222c-0.047,5.434-0.086,9.968-0.114,13.206c-0.024,1.531-0.044,2.753-0.058,3.647 c-0.01,0.382-0.019,0.693-0.026,0.945C438.665,309.996,438.657,310.1,438.649,310.092z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.583,
    y: 292.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.583,
    y: 305.347,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.646,300.506c0,0.144-4.478,0.26-10.001,0.26c-5.525,0-10.002-0.116-10.002-0.26c0-0.144,4.477-0.26,10.002-0.26 C434.168,300.246,438.646,300.362,438.646,300.506z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398.249,
    y: 310.172,
    style: {
      fill: "#455A64"
    },
    width: 19.714,
    height: 18.106
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.963,328.278c-0.008-0.008-0.017-0.129-0.025-0.355c-0.007-0.264-0.015-0.589-0.026-0.988 c-0.014-0.906-0.034-2.145-0.058-3.697c-0.028-3.203-0.067-7.69-0.114-13.066l0.222,0.222 c-5.703,0.011-12.47,0.024-19.712,0.038c-0.059,0.056,0.491-0.492,0.259-0.257v0.005v0.01v0.019v0.039v0.077v0.154v0.308 l0,0.615c0,0.409,0,0.817,0,1.223c0,0.811-0.001,1.616-0.001,2.412c-0.002,1.592-0.004,3.152-0.006,4.672 c-0.008,3.036-0.016,5.912-0.024,8.569l-0.228-0.228c5.826,0.047,10.713,0.087,14.205,0.116 c1.696,0.025,3.052,0.045,4.039,0.06c0.438,0.011,0.794,0.02,1.081,0.027C417.822,328.26,417.954,328.269,417.963,328.278 c0.009,0.009-0.107,0.017-0.338,0.026c-0.275,0.007-0.616,0.016-1.037,0.027c-0.975,0.015-2.313,0.035-3.988,0.06 c-3.528,0.029-8.465,0.068-14.352,0.116l-0.228,0.002l-0.001-0.23c-0.007-2.657-0.015-5.533-0.024-8.569 c-0.002-1.52-0.004-3.08-0.006-4.672c-0.001-0.796-0.001-1.601-0.002-2.412c0-0.406,0-0.813-0.001-1.223l0-0.615v-0.308 v-0.154v-0.077v-0.039v-0.019v-0.01v-0.005c-0.233,0.231,0.317-0.321,0.262-0.263c7.242,0.014,14.009,0.027,19.712,0.038 l0.224,0l-0.002,0.222c-0.047,5.434-0.086,9.968-0.114,13.206c-0.024,1.531-0.044,2.753-0.058,3.647 c-0.01,0.382-0.019,0.693-0.026,0.945C417.979,328.181,417.971,328.286,417.963,328.278z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.897,
    y: 310.51,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.897,
    y: 323.533,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.96,318.692c0,0.144-4.478,0.26-10.001,0.26c-5.525,0-10.002-0.117-10.002-0.26s4.477-0.26,10.002-0.26 C413.482,318.431,417.96,318.548,417.96,318.692z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398.249,
    y: 291.986,
    style: {
      fill: "#455A64"
    },
    width: 19.714,
    height: 18.106
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.963,310.092c-0.008-0.008-0.017-0.129-0.025-0.356c-0.007-0.264-0.015-0.589-0.026-0.988 c-0.014-0.906-0.034-2.145-0.058-3.697c-0.028-3.203-0.067-7.69-0.114-13.065l0.222,0.222 c-5.703,0.011-12.47,0.024-19.712,0.038c-0.059,0.056,0.491-0.492,0.259-0.257v0.005v0.01v0.019v0.039v0.077v0.155v0.308 l0,0.615c0,0.409,0,0.817,0,1.223c0,0.811-0.001,1.616-0.001,2.412c-0.002,1.592-0.004,3.152-0.006,4.672 c-0.008,3.036-0.016,5.912-0.024,8.569l-0.228-0.228c5.826,0.047,10.713,0.087,14.205,0.116 c1.696,0.025,3.052,0.045,4.039,0.06c0.438,0.011,0.794,0.02,1.081,0.027C417.822,310.074,417.954,310.083,417.963,310.092 c0.009,0.009-0.107,0.017-0.338,0.026c-0.275,0.007-0.616,0.016-1.037,0.027c-0.975,0.015-2.313,0.035-3.988,0.06 c-3.528,0.028-8.465,0.068-14.352,0.116l-0.228,0.002l-0.001-0.23c-0.007-2.657-0.015-5.533-0.024-8.569 c-0.002-1.52-0.004-3.079-0.006-4.672c-0.001-0.796-0.001-1.6-0.002-2.412c0-0.406,0-0.813-0.001-1.223l0-0.615v-0.308v-0.155 v-0.077v-0.039v-0.019v-0.01v-0.005c-0.233,0.231,0.317-0.321,0.262-0.263c7.242,0.014,14.009,0.027,19.712,0.038l0.224,0 l-0.002,0.222c-0.047,5.434-0.086,9.968-0.114,13.206c-0.024,1.531-0.044,2.753-0.058,3.647 c-0.01,0.382-0.019,0.693-0.026,0.945C417.979,309.996,417.971,310.1,417.963,310.092z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.897,
    y: 292.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.897,
    y: 305.347,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.626,
    height: 4.533
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.96,300.506c0,0.144-4.478,0.26-10.001,0.26c-5.525,0-10.002-0.116-10.002-0.26c0-0.144,4.477-0.26,10.002-0.26 C413.482,300.246,417.96,300.362,417.96,300.506z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 406.473,
    y: 330.206,
    style: {
      fill: "#263238"
    },
    width: 33.947,
    height: 1.159
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395.361,
    y: 328.035,
    style: {
      fill: "#AE7461"
    },
    width: 44.856,
    height: 2.583
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395.431,
    y: 330.618,
    style: {
      fill: "#AE7461"
    },
    width: 3.983,
    height: 3.034
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 395.431,
    y: 330.618,
    width: 3.983,
    height: 0.733
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.797,
    y: 330.618,
    style: {
      fill: "#AE7461"
    },
    width: 3.983,
    height: 3.034
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 415.797,
    y: 330.618,
    width: 3.983,
    height: 0.733
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 436.234,
    y: 330.618,
    style: {
      fill: "#AE7461"
    },
    width: 3.983,
    height: 3.034
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 436.234,
    y: 330.618,
    width: 3.983,
    height: 0.733
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M498.417,324.936c0,0.144-5.465,0.26-12.204,0.26c-6.742,0-12.205-0.117-12.205-0.26c0-0.144,5.464-0.26,12.205-0.26 C492.953,324.676,498.417,324.793,498.417,324.936z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M510.176,341.905c0,0.063-0.842,0.12-2.245,0.165c-1.403,0.045-3.368,0.077-5.613,0.09 l-0.254,0.001l-0.001-0.256c-0.002-0.668-0.004-1.359-0.006-2.068c0-2.742,0.029-5.223,0.076-7.02 c0.047-1.796,0.112-2.907,0.184-2.907c0.072,0,0.137,1.111,0.184,2.907c0.047,1.796,0.076,4.278,0.076,7.02 c-0.002,0.709-0.004,1.399-0.006,2.068l-0.255-0.255c2.245,0.013,4.21,0.045,5.613,0.09 C509.334,341.785,510.176,341.842,510.176,341.905z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.408,338.072h-0.109c-0.166,0-0.301-0.135-0.301-0.301v-5.859c0-0.166,0.135-0.301,0.301-0.301h0.109 c0.166,0,0.301,0.135,0.301,0.301v5.859C504.709,337.937,504.574,338.072,504.408,338.072z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.766,338.072h-0.109c-0.166,0-0.301-0.135-0.301-0.301v-5.859c0-0.166,0.135-0.301,0.301-0.301h0.109 c0.166,0,0.301,0.135,0.301,0.301v5.859C506.067,337.937,505.932,338.072,505.766,338.072z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.124,338.072h-0.109c-0.166,0-0.301-0.135-0.301-0.301v-5.859c0-0.166,0.135-0.301,0.301-0.301h0.109 c0.166,0,0.301,0.135,0.301,0.301v5.859C507.425,337.937,507.29,338.072,507.124,338.072z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.482,338.072h-0.109c-0.166,0-0.301-0.135-0.301-0.301v-5.859c0-0.166,0.135-0.301,0.301-0.301h0.109 c0.166,0,0.301,0.135,0.301,0.301v5.859C508.783,337.937,508.648,338.072,508.482,338.072z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M502.762,341.905c0,0.144-12.134,0.26-27.1,0.26c-14.97,0-27.102-0.117-27.102-0.26 s12.132-0.26,27.102-0.26C490.628,341.644,502.762,341.761,502.762,341.905z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.398,
    y: 398.972,
    style: {
      fill: "#263238"
    },
    width: 76.523,
    height: 44.094
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.908,
    y: 421.045,
    style: {
      fill: "#455A64"
    },
    width: 86.404,
    height: 20.983
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "158.388,415.327 158.388,443.066 181.236,443.066 190.395,429.79 384.021,429.79  384.021,415.327  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M152.524,310.951c-0.058-1.039-0.935-1.84-1.975-1.797 c-10.103,0.415-58.085,2.615-67.951,7.358c-7.55,3.63-15.824,17.196-21.658,26.329 c-4.181,6.546-13.42,21.083-15.288,28.513c-1.583,6.294-2.535,19.355-2.426,25.844l0.543,34.308h45.578l4.354-11.331 c2.84-7.392,9.941-12.27,17.86-12.27h43.208v-56.937L152.524,310.951z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M77.445,320.308c-5.985,5.712-11.978,15.448-16.504,22.533 c-3.872,6.061-12.077,18.971-14.756,26.749c-0.05,0.145-0.091,0.281-0.137,0.422c1.325-0.367,3.362-1.115,3.988-2.368 c0.953-1.905,2.177-8.421,17.29-33.029C71.932,327.117,76.413,322.728,77.445,320.308z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M42.664,400.178c0.003-0.626,0.254-1.113,0.572-1.117l6.979-0.089 c0.584-0.007,1.019,1.106,0.985,2.395l-0.111,5.339c-0.018,0.857-0.332,1.558-0.718,1.593l-7.159,0.655 c-0.323,0.029-0.589-0.466-0.586-1.097L42.664,400.178z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 425.429,
    style: {
      fill: "#263238"
    },
    width: 50.056,
    height: 20.069
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.422,438.693c-0.218,15.123,11.864,27.559,26.987,27.777 c15.123,0.218,27.559-11.865,27.778-26.987c0.218-15.123-11.865-27.559-26.988-27.777 C110.077,411.488,97.64,423.57,97.422,438.693z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.427,438.623c-0.001,0.024-0.004,0.047-0.005,0.071 c-0.218,15.123,11.864,27.559,26.987,27.777c15.123,0.218,27.559-11.865,27.778-26.987 c0-0.024-0.003-0.047-0.003-0.071L97.427,438.623z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M105.58,438.811c-0.153,10.617,8.33,19.349,18.947,19.502 c10.618,0.153,19.349-8.33,19.502-18.947c0.153-10.617-8.33-19.349-18.947-19.502 C114.465,419.711,105.734,428.194,105.58,438.811z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M125.082,419.864c-10.617-0.153-19.348,8.33-19.501,18.947l38.449,0.555 C144.182,428.748,135.699,420.017,125.082,419.864z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M113.094,438.919c-0.093,6.468,5.074,11.786,11.541,11.879 c6.468,0.093,11.787-5.074,11.88-11.542c0.093-6.468-5.074-11.786-11.542-11.88 C118.506,427.284,113.188,432.452,113.094,438.919z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M94.705,445.665l-5.75-0.669c1.193-16.367,4.134-25.822,6.537-29.597 c4.618-7.255,9.206-8.564,14.295-9.434c4.731-0.807,9.505-0.614,14.121-0.428l1.133,0.045 c9.53,0.371,29.491,0.041,29.692,0.038l0.077,4.569c-0.201,0.003-20.29,0.336-29.947-0.04l-1.14-0.046 c-4.381-0.176-8.91-0.36-13.167,0.367c-4.544,0.776-7.566,1.66-11.209,7.383 C98.244,419.585,96.175,425.502,94.705,445.665z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M378.277,415.187H158.674c-0.158,0-0.286-0.128-0.286-0.286V281.557 c0-0.158,0.128-0.286,0.286-0.286h219.603c0.158,0,0.286,0.128,0.286,0.286v133.344 C378.563,415.059,378.435,415.187,378.277,415.187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.277,415.187c-0.032-0.007,0.245,0.026,0.273-0.297 c-0.003-0.313-0.007-0.767-0.013-1.367c-0.006-1.215-0.015-3.01-0.026-5.362c-0.011-4.721-0.028-11.671-0.049-20.619 c-0.02-17.913-0.048-43.821-0.083-75.833c-0.005-8.004-0.011-16.39-0.017-25.128c-0.001-1.092-0.001-2.19-0.002-3.293 l-0.001-1.659c0.006-0.143-0.014-0.111-0.053-0.148c-0.009-0.003-0.018-0.005-0.029-0.005h-0.103l-0.208,0l-0.835,0.001 c-2.228,0.001-4.477,0.003-6.748,0.004c-4.541,0.002-9.167,0.005-13.872,0.007c-18.824,0.008-38.937,0.016-60.102,0.024 c-42.331,0.006-88.869,0.013-137.717,0.02c-0.016,24.282-0.032,47.988-0.048,70.883 c-0.002,11.519-0.004,22.833-0.006,33.915c-0.001,5.541-0.003,11.023-0.004,16.443c-0.001,2.71-0.001,5.404-0.002,8.083 c0,1.339-0.001,2.674-0.001,4.006c0,0.094,0.011,0.072,0.055,0.085l0.499,0l0.996,0l1.988,0.001 c42.335,0.021,80.459,0.04,112.478,0.056c32.012,0.035,57.918,0.063,75.829,0.083 c8.947,0.021,15.896,0.038,20.616,0.049c2.352,0.011,4.147,0.02,5.361,0.026 C377.658,415.169,378.277,415.187,378.277,415.187s-0.619,0.018-1.827,0.027c-1.215,0.006-3.01,0.015-5.361,0.026 c-4.72,0.011-11.669,0.028-20.616,0.049c-17.911,0.02-43.816,0.048-75.829,0.083 c-32.018,0.016-70.142,0.035-112.478,0.056l-1.988,0.001l-0.996,0l-0.499,0c-0.301,0.036-0.585-0.323-0.537-0.567 c0-1.331-0.001-2.667-0.001-4.006c-0.001-2.678-0.001-5.373-0.002-8.083c-0.001-5.42-0.003-10.902-0.004-16.443 c-0.002-11.081-0.004-22.396-0.006-33.915c-0.001-11.519-0.003-23.241-0.004-35.139c0-5.949-0.001-11.941-0.001-17.973 c0-3.016,0-6.042,0-9.078c0-1.518,0-3.038,0-4.56v-2.285v-1.144v-0.572c-0.002-0.055-0.015-0.279,0.105-0.428 c0.098-0.149,0.308-0.235,0.458-0.225c48.848,0.007,95.386,0.014,137.717,0.02c21.165,0.008,41.278,0.016,60.102,0.024 c4.706,0.003,9.331,0.005,13.872,0.007c2.271,0.001,4.52,0.003,6.748,0.004l0.835,0l0.208,0l0.105,0 c0.059,0,0.119,0.012,0.174,0.033c0.234,0.06,0.348,0.398,0.313,0.529l-0.001,1.659 c-0.001,1.103-0.001,2.201-0.002,3.293c-0.006,8.738-0.012,17.123-0.017,25.128c-0.035,32.012-0.063,57.92-0.083,75.833 c-0.021,8.948-0.038,15.898-0.049,20.619c-0.011,2.352-0.02,4.147-0.026,5.362c-0.006,0.599-0.01,1.054-0.013,1.367 C378.533,415.239,378.241,415.186,378.277,415.187z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9963 -0.0862 0.0862 0.9963 -36.942 28.6278)",
    style: {
      fill: "#263238"
    },
    cx: 312.962,
    cy: 442.002,
    rx: 24.471,
    ry: 24.471
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M288.498,441.586c0,0.021-0.004,0.042-0.004,0.063 c-0.195,13.513,10.602,24.627,24.116,24.821c13.514,0.195,24.627-10.602,24.822-24.116 c0-0.021-0.002-0.042-0.002-0.063L288.498,441.586z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M295.784,441.754c-0.137,9.488,7.443,17.29,16.931,17.427 c9.488,0.137,17.29-7.443,17.427-16.931c0.137-9.488-7.443-17.29-16.931-17.427 C303.722,424.687,295.92,432.267,295.784,441.754z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M313.21,424.823c-9.488-0.137-17.289,7.444-17.426,16.931l34.357,0.496 C330.278,432.763,322.698,424.96,313.21,424.823z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M302.498,441.851c-0.083,5.78,4.534,10.532,10.313,10.615 c5.779,0.083,10.532-4.534,10.616-10.313c0.083-5.779-4.534-10.532-10.314-10.615 C307.334,431.454,302.581,436.072,302.498,441.851z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M280.793,448.706c0,0-3.728-34.705,32.241-34.705c33.189,0,32.449,29.856,32.136,34.473 h-5.205c0,0,2.652-29.422-26.931-29.422c-29.582,0-27.005,30.02-27.005,30.02S283.844,448.956,280.793,448.706z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M61.234,374c0.511,0.17,25.897,0,25.897,0l55.882-21.467v-36.289c0,0-37.652,2.044-45.149,3.237 c-7.496,1.193-12.553,7.977-16.185,13.52C76.712,340.58,61.234,374,61.234,374z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M61.234,374c0,0,0.063-0.18,0.22-0.535c0.164-0.366,0.394-0.88,0.694-1.548 c0.632-1.372,1.552-3.367,2.733-5.93c2.407-5.138,5.888-12.585,10.449-21.691c1.139-2.277,2.364-4.649,3.683-7.101 c1.316-2.454,2.823-4.951,4.593-7.381c1.771-2.425,3.766-4.869,6.304-6.881c2.501-2.012,5.65-3.554,9.073-3.841 c6.734-0.78,13.823-1.22,21.184-1.731c7.362-0.485,14.996-0.945,22.832-1.378l0.274-0.015v0.275c0,1.457,0,3.027,0,4.605 c-0.003,11.008-0.007,21.662-0.01,31.685v0.173l-0.161,0.062c-22.521,8.613-42.004,16.064-55.914,21.384l-0.028,0.011h-0.029 c-8.166,0-14.636,0-19.085,0.001c-2.2-0.028-3.899-0.049-5.068-0.064c-0.562-0.02-0.993-0.036-1.304-0.047 C61.369,374.029,61.234,374,61.234,374s2.383,0.017,6.812-0.012c4.448-0.035,10.917-0.086,19.083-0.15l-0.057,0.011 c13.894-5.361,33.354-12.87,55.85-21.55l-0.161,0.234c-0.003-10.023-0.006-20.677-0.01-31.685c0-1.577,0-3.147,0-4.605 l0.274,0.26c-7.833,0.432-15.468,0.886-22.827,1.363c-7.354,0.503-14.457,0.933-21.155,1.695 c-3.36,0.278-6.383,1.757-8.854,3.725c-2.493,1.965-4.475,4.375-6.24,6.776c-1.771,2.415-3.268,4.878-4.591,7.321 c-1.325,2.441-2.559,4.805-3.707,7.076c-4.6,9.078-8.131,16.501-10.593,21.612c-1.218,2.545-2.167,4.526-2.819,5.889 c-0.319,0.659-0.565,1.166-0.739,1.527C61.335,373.825,61.234,374,61.234,374z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.415,374.076c0.486-0.01,14.501-39.391,21.502-42.195c7.001-2.805,48.095-4.737,48.095-4.737v-10.899l-38.718,2.003 c-9.623,0.498-18.271,6.033-22.753,14.563L61.747,374L73.415,374.076z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M87.13,374l4.296-51.907l2.644-1.471l-3.47,39.919c0,0,4.538-2.385,18.338-3.919 c13.8-1.533,34.074-4.089,34.074-4.089L87.13,374z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M58.844,421.345c0,0,0.059,0.36,0.148,1.063c0.087,0.714,0.214,1.756,0.381,3.121 c0.325,2.757,0.802,6.811,1.42,12.056l-0.104-0.092c6.976-0.015,16.202-0.035,27.247-0.06l-0.163,0.148 c0.576-3.287,1.484-6.635,2.391-10.18c0.969-3.516,1.777-7.278,3.382-10.96c1.604-3.654,4.167-7.139,7.723-9.621 c3.589-2.4,8.015-3.835,12.645-3.691l-0.019-0.001c10.403-0.029,21.775-0.06,33.715-0.092l-0.243,0.245 c-0.166-21.075-0.36-44.194-0.338-68.351c0.012-3.336,0.021-6.65,0.092-9.95c0.032-1.656,0.141-3.29,0.193-4.921 c0.037-1.625,0.116-3.267-0.129-4.829c-0.131-0.766-0.352-1.546-0.889-2.029c-0.537-0.467-1.317-0.672-2.092-0.654 c-1.574-0.013-3.192,0.104-4.78,0.205c-3.188,0.214-6.348,0.483-9.481,0.751c-6.263,0.572-12.414,1.134-18.439,1.685 c-3.012,0.282-5.993,0.561-8.939,0.837c-1.474,0.133-2.94,0.265-4.397,0.396c-1.459,0.12-2.864,0.344-4.247,0.722 c-2.754,0.775-5.28,2.136-7.578,3.716c-2.299,1.59-4.364,3.456-6.187,5.469c-3.464,4.193-6.328,8.704-8.945,13.107 c-5.172,8.862-9.323,17.529-12.296,25.729c-0.736,2.05-1.374,4.089-1.777,6.109c-0.389,2.022-0.351,4.056-0.37,6.018 c0.004,3.932,0.157,7.642,0.303,11.11c0.306,6.935,0.666,12.905,0.958,17.784c0.294,4.871,0.522,8.655,0.678,11.236 c0.062,1.277,0.11,2.253,0.142,2.925C58.883,421.006,58.844,421.345,58.844,421.345s-0.053-1.348-0.242-3.916 c-0.178-2.58-0.439-6.362-0.775-11.23c-0.323-4.877-0.712-10.846-1.046-17.783c-0.16-3.469-0.326-7.18-0.344-11.122 c0.014-1.965-0.033-4.014,0.357-6.082c0.403-2.057,1.04-4.106,1.773-6.168c1.46-4.13,3.267-8.349,5.313-12.665 c2.053-4.313,4.356-8.72,6.958-13.161c2.623-4.428,5.469-8.935,8.975-13.193c1.847-2.045,3.93-3.933,6.261-5.55 c2.329-1.606,4.897-2.996,7.715-3.792c1.406-0.388,2.879-0.623,4.336-0.743c1.456-0.133,2.921-0.266,4.394-0.4 c2.946-0.279,5.926-0.56,8.938-0.845c6.026-0.555,12.178-1.121,18.442-1.698c3.134-0.27,6.296-0.54,9.49-0.756 c1.602-0.101,3.192-0.221,4.841-0.207c0.82-0.012,1.722,0.189,2.415,0.788c0.681,0.625,0.909,1.519,1.051,2.326 c0.257,1.654,0.173,3.292,0.137,4.932c-0.051,1.638-0.161,3.28-0.192,4.918c-0.07,3.286-0.079,6.603-0.091,9.937 c-0.023,24.151,0.16,47.271,0.304,68.345l0.002,0.245l-0.245,0c-11.94,0.016-23.311,0.032-33.715,0.047l-0.019-0.001 c-4.481-0.147-8.866,1.251-12.373,3.595c-3.486,2.424-6.011,5.835-7.602,9.436c-1.587,3.614-2.411,7.38-3.389,10.892 c-0.915,3.526-1.837,6.911-2.413,10.121l-0.027,0.148l-0.137,0c-11.045-0.024-20.271-0.044-27.247-0.06l-0.094,0l-0.01-0.093 c-0.575-5.258-1.019-9.322-1.321-12.085c-0.143-1.365-0.253-2.407-0.328-3.121C58.866,421.702,58.844,421.345,58.844,421.345z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M138.437,377.191c-0.001-0.024,0.161-0.023,0.439-0.115c0.27-0.092,0.675-0.316,0.928-0.8 c0.272-0.469,0.13-1.195,0.141-1.999c-0.011-0.748-0.739-1.539-1.73-1.417c-4.094,0.047-9.75,0.076-15.997,0.076 c-0.668-0.01-1.278,0.512-1.377,1.153c-0.046,0.289-0.014,0.731-0.025,1.086c-0.007,0.398-0.008,0.687,0.143,0.975 c0.135,0.281,0.367,0.511,0.643,0.644c0.284,0.148,0.561,0.152,0.937,0.147c0.708,0.003,1.401,0.006,2.079,0.009 c2.686,0.021,5.117,0.04,7.192,0.056c1.983,0.034,3.618,0.062,4.849,0.083C137.804,377.121,138.437,377.155,138.437,377.191 c0,0.036-0.633,0.07-1.778,0.101c-1.23,0.021-2.866,0.049-4.849,0.083c-2.074,0.016-4.506,0.035-7.192,0.056 c-0.677,0.003-1.371,0.006-2.079,0.009c-0.326,0.011-0.793,0.007-1.158-0.191c-0.376-0.18-0.692-0.49-0.879-0.872 c-0.208-0.373-0.208-0.856-0.2-1.201c0.013-0.393-0.031-0.711,0.029-1.176c0.134-0.881,0.97-1.599,1.887-1.584 c6.247,0,11.903,0.029,15.997,0.076c0.52-0.04,1.107,0.147,1.46,0.506c0.37,0.349,0.557,0.828,0.561,1.269 c-0.007,0.403-0.013,0.783-0.018,1.138c0.009,0.357-0.084,0.709-0.236,0.968c-0.316,0.531-0.781,0.739-1.077,0.804 C138.599,377.241,138.436,377.203,138.437,377.191z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M65.214,359.125h-3.017c-2.302,0-4.168-1.866-4.168-4.168v-18.909 c0-2.302,1.866-4.168,4.168-4.168h3.017c2.302,0,4.168,1.866,4.168,4.168v18.909 C69.382,357.259,67.516,359.125,65.214,359.125z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M61.418,370.883h-0.571v-28.807c0-2.858,2.325-5.182,5.182-5.182h1.369v0.571h-1.369 c-2.542,0-4.611,2.069-4.611,4.611V370.883z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M65.311,370.919l-1.588-26.938c-0.056-0.943,0.271-1.841,0.918-2.527 c0.648-0.687,1.524-1.066,2.469-1.066v0.571c-0.785,0-1.514,0.315-2.053,0.886c-0.539,0.571-0.81,1.318-0.764,2.102 l1.588,26.938L65.311,370.919z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.407,
    y: 368.287,
    style: {
      fill: "#263238"
    },
    width: 7.703,
    height: 8.919
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.133,
    y: 351.362,
    style: {
      fill: "#263238"
    },
    width: 3.133,
    height: 0.571
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M83.086,330.912c-0.181,0.307,40.008,29.273,40.008,29.273l14.493-5.567L94.07,320.623 C94.07,320.623,88.431,321.832,83.086,330.912z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "78.721,338.144 113.905,363.715 108.066,365.958 75.93,343.506  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.439,411.703c0,0-0.014-0.773-0.022-2.259c-0.005-1.49-0.013-3.693-0.022-6.575 c-0.012-5.77-0.029-14.255-0.051-25.145c-0.026-21.762-0.062-53.133-0.107-91.598l0.202,0.202 c-56.742,0.016-130.286,0.036-210.371,0.058h-0.016l0.26-0.26c-0.007,44.479-0.013,86.936-0.019,125.578l-0.241-0.242 c61.689,0.048,114.255,0.089,151.407,0.118c18.59,0.028,33.322,0.05,43.414,0.065c5.045,0.013,8.929,0.023,11.561,0.03 c1.31,0.006,2.307,0.011,2.984,0.014C373.09,411.693,373.439,411.703,373.439,411.703s-0.33,0.01-0.992,0.014 c-0.671,0.003-1.658,0.008-2.956,0.014c-2.62,0.007-6.488,0.017-11.512,0.03c-10.08,0.015-24.793,0.037-43.36,0.065 c-37.192,0.029-89.813,0.07-151.567,0.118l-0.242,0v-0.242c-0.006-38.642-0.012-81.099-0.019-125.578v-0.26h0.26h0.016 c80.085,0.022,153.629,0.042,210.371,0.058l0.203,0l0,0.202c-0.045,38.518-0.082,69.931-0.107,91.723 c-0.022,10.871-0.039,19.34-0.051,25.1c-0.01,2.866-0.017,5.056-0.022,6.538C373.454,410.958,373.439,411.703,373.439,411.703z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M574.497,189.607l7.25-9.276c8.723-1.754,17.046-6.123,23.717-13.164 c15.734-16.608,16.25-42.956,1.215-60.2c-17.373-19.925-48.127-20.664-66.43-1.318 c-15.539,16.424-16.249,42.359-1.658,59.63c7.24,8.571,16.917,13.7,27.073,15.346l-0.026,0.003L574.497,189.607z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M574.497,189.607c0,0-0.193-0.167-0.576-0.538c-0.412-0.404-0.98-0.96-1.713-1.678 c-1.552-1.539-3.796-3.766-6.693-6.64c-0.068-0.067-0.068-0.176-0.001-0.244c0.029-0.029,0.069-0.046,0.107-0.05 c0,0,0.016-0.002,0.025-0.003l-0.01,0.344c-5.498-0.87-12.836-3.053-19.971-8.43 c-3.558-2.662-6.974-6.123-9.946-10.326c-2.933-4.224-5.302-9.26-6.686-14.861 c-1.358-5.602-1.688-11.763-0.699-17.992c0.994-6.211,3.247-12.546,7.103-18.128 c3.799-5.599,9.014-10.493,15.218-14.047c6.189-3.598,13.468-5.583,20.909-5.793c3.77-0.201,7.497,0.323,11.121,1.011 c1.782,0.476,3.572,0.926,5.293,1.532l2.542,1.009l1.262,0.509l1.203,0.629c6.477,3.225,11.94,7.957,16.066,13.397 c4.169,5.438,6.715,11.738,7.991,17.951c1.264,6.237,1.178,12.458,0.038,18.149 c-1.162,5.694-3.346,10.852-6.122,15.212c-0.746,1.056-1.479,2.094-2.2,3.115c-0.744,1.002-1.6,1.89-2.372,2.814 c-1.576,1.824-3.307,3.384-5.024,4.795c-6.947,5.643-14.18,8.092-19.58,9.152l0.099-0.061 c-2.368,2.961-4.211,5.265-5.49,6.864c-0.602,0.744-1.072,1.323-1.413,1.745 C574.659,189.432,574.498,189.622,574.497,189.607c0,0,0.159-0.235,0.47-0.651c0.333-0.441,0.79-1.047,1.377-1.825 c1.227-1.608,2.998-3.926,5.271-6.903c0.025-0.032,0.063-0.054,0.1-0.062c5.346-1.127,12.479-3.622,19.301-9.245 c1.686-1.406,3.387-2.959,4.931-4.768c0.756-0.917,1.595-1.796,2.323-2.789c0.705-1.01,1.423-2.038,2.152-3.083 c2.714-4.312,4.84-9.402,5.962-15.012c1.1-5.608,1.162-11.729-0.098-17.857c-1.273-6.104-3.786-12.285-7.889-17.616 c-4.062-5.333-9.431-9.972-15.788-13.129l-1.18-0.617l-1.239-0.498l-2.495-0.989c-1.689-0.594-3.446-1.034-5.194-1.5 c-3.557-0.672-7.214-1.188-10.913-0.99c-7.301,0.206-14.443,2.148-20.517,5.674 c-6.09,3.481-11.219,8.282-14.956,13.77c-3.797,5.471-6.023,11.688-7.017,17.792 c-0.989,6.121-0.685,12.184,0.629,17.702c1.341,5.518,3.65,10.488,6.519,14.666c2.907,4.157,6.258,7.596,9.754,10.249 c7.009,5.36,14.248,7.591,19.694,8.528c0.094,0.015,0.159,0.103,0.145,0.198c-0.012,0.079-0.079,0.137-0.155,0.146 c-0.009,0.001-0.025,0.003-0.025,0.003l0.106-0.294c2.802,2.902,4.973,5.151,6.474,6.705 c0.721,0.755,1.28,1.341,1.685,1.765C574.3,189.38,574.497,189.607,574.497,189.607z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF725E"
    },
    points: "571.51,116.783 551.466,125.464 551.466,148.536 571.51,157.879 591.553,149.51  591.553,124.96  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "571.519,134.864 551.171,126.154 551.761,124.776 571.501,133.225 591.243,124.277  591.863,125.643  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 570.76,
    y: 134.044,
    style: {
      fill: "#FFFFFF"
    },
    width: 1.499,
    height: 23.835
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#455A64"
    },
    cx: 591.071,
    cy: 149.324,
    r: 7.079
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "587.305,149.525 588.345,148.374 590.551,150.145 593.828,146.382 594.9,147.426  590.501,152.265  "
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientWelcome);
export default __webpack_public_path__ + "static/media/client_welcome.e10002227a38952adf8146e371313927.svg";
export { ForwardRef as ReactComponent };